webpackJsonp([114276838955818,60335399758886],{

/***/ 172:
/***/ (function(module, exports) {

	module.exports = {"data":{"allImageSharp":{"edges":[{"node":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAOABQDASIAAhEBAxEB/8QAGAAAAwEBAAAAAAAAAAAAAAAAAAMEAQL/xAAVAQEBAAAAAAAAAAAAAAAAAAAAAf/aAAwDAQACEAMQAAABhdH1Giw//8QAGRAAAgMBAAAAAAAAAAAAAAAAAAIQETES/9oACAEBAAEFAk0bbOo//8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAwEBPwE//8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAgEBPwE//8QAFBABAAAAAAAAAAAAAAAAAAAAIP/aAAgBAQAGPwJf/8QAGRAAAwEBAQAAAAAAAAAAAAAAAAERIWGB/9oACAEBAAE/IdV4WPUNaZerpUQ3Wz//2gAMAwEAAgADAAAAEK//AP/EABURAQEAAAAAAAAAAAAAAAAAAAEQ/9oACAEDAQE/EGf/xAAVEQEBAAAAAAAAAAAAAAAAAAABEP/aAAgBAgEBPxAn/8QAGhABAAMBAQEAAAAAAAAAAAAAAQARITFBcf/aAAgBAQABPxB09tNkjjwQdNgqmoc+ShHjeKFuGSxV7P/Z","aspectRatio":1.3937282229965158,"src":"/static/7d3a5eb364a4ca74d418300828c86c60/381d6/agenda_base.jpg","srcSet":"/static/7d3a5eb364a4ca74d418300828c86c60/62f05/agenda_base.jpg 200w,\n/static/7d3a5eb364a4ca74d418300828c86c60/dc2b4/agenda_base.jpg 400w,\n/static/7d3a5eb364a4ca74d418300828c86c60/381d6/agenda_base.jpg 800w","sizes":"(max-width: 800px) 100vw, 800px"}}},{"node":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAOABQDASIAAhEBAxEB/8QAGAAAAwEBAAAAAAAAAAAAAAAAAAMEAQL/xAAVAQEBAAAAAAAAAAAAAAAAAAAAAf/aAAwDAQACEAMQAAABhdH1Giw//8QAGRAAAgMBAAAAAAAAAAAAAAAAAAIQETES/9oACAEBAAEFAk0bbOo//8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAwEBPwE//8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAgEBPwE//8QAFBABAAAAAAAAAAAAAAAAAAAAIP/aAAgBAQAGPwJf/8QAGRAAAwEBAQAAAAAAAAAAAAAAAAERIWGB/9oACAEBAAE/IdV4WPUNaZerpUQ3Wz//2gAMAwEAAgADAAAAEK//AP/EABURAQEAAAAAAAAAAAAAAAAAAAEQ/9oACAEDAQE/EGf/xAAVEQEBAAAAAAAAAAAAAAAAAAABEP/aAAgBAgEBPxAn/8QAGhABAAMBAQEAAAAAAAAAAAAAAQARITFBcf/aAAgBAQABPxB09tNkjjwQdNgqmoc+ShHjeKFuGSxV7P/Z","aspectRatio":1.3937282229965158,"src":"/static/7d3a5eb364a4ca74d418300828c86c60/381d6/agenda_hover.jpg","srcSet":"/static/7d3a5eb364a4ca74d418300828c86c60/62f05/agenda_hover.jpg 200w,\n/static/7d3a5eb364a4ca74d418300828c86c60/dc2b4/agenda_hover.jpg 400w,\n/static/7d3a5eb364a4ca74d418300828c86c60/381d6/agenda_hover.jpg 800w","sizes":"(max-width: 800px) 100vw, 800px"}}},{"node":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAPABQDASIAAhEBAxEB/8QAFgABAQEAAAAAAAAAAAAAAAAABQAD/8QAFgEBAQEAAAAAAAAAAAAAAAAAAAEC/9oADAMBAAIQAxAAAAFDcHbFRg4//8QAGhAAAgMBAQAAAAAAAAAAAAAAAQMAAhIiMf/aAAgBAQABBQJT9DXJbPIGZrYix//EABURAQEAAAAAAAAAAAAAAAAAAAAR/9oACAEDAQE/AYj/xAAWEQEBAQAAAAAAAAAAAAAAAAAAEgH/2gAIAQIBAT8BpWv/xAAaEAACAgMAAAAAAAAAAAAAAAAAARFRISIx/9oACAEBAAY/AthWziHkiiT/xAAcEAADAAEFAAAAAAAAAAAAAAAAAREhMUFRYcH/2gAIAQEAAT8hwEXSnEUKQfoV4Go9LVvsbJH/2gAMAwEAAgADAAAAEEMP/8QAFhEBAQEAAAAAAAAAAAAAAAAAAAER/9oACAEDAQE/EKYf/8QAFxEBAQEBAAAAAAAAAAAAAAAAAQAhYf/aAAgBAgEBPxAQbdL/xAAcEAEAAwACAwAAAAAAAAAAAAABABEhMUFhcYH/2gAIAQEAAT8QEKFnWherIJVAK3D7EqYKIotAAHzAFAFvl6jYL1oJ/9k=","aspectRatio":1.3266998341625207,"src":"/static/09d421399df2a0ed4dd800fe935768f9/381d6/pubbl_base.jpg","srcSet":"/static/09d421399df2a0ed4dd800fe935768f9/62f05/pubbl_base.jpg 200w,\n/static/09d421399df2a0ed4dd800fe935768f9/dc2b4/pubbl_base.jpg 400w,\n/static/09d421399df2a0ed4dd800fe935768f9/381d6/pubbl_base.jpg 800w","sizes":"(max-width: 800px) 100vw, 800px"}}},{"node":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAPABQDASIAAhEBAxEB/8QAFgABAQEAAAAAAAAAAAAAAAAABQAD/8QAFgEBAQEAAAAAAAAAAAAAAAAAAAEC/9oADAMBAAIQAxAAAAFDcHbFRg4//8QAGhAAAgMBAQAAAAAAAAAAAAAAAQMAAhIiMf/aAAgBAQABBQJT9DXJbPIGZrYix//EABURAQEAAAAAAAAAAAAAAAAAAAAR/9oACAEDAQE/AYj/xAAWEQEBAQAAAAAAAAAAAAAAAAAAEgH/2gAIAQIBAT8BpWv/xAAaEAACAgMAAAAAAAAAAAAAAAAAARFRISIx/9oACAEBAAY/AthWziHkiiT/xAAcEAADAAEFAAAAAAAAAAAAAAAAAREhMUFRYcH/2gAIAQEAAT8hwEXSnEUKQfoV4Go9LVvsbJH/2gAMAwEAAgADAAAAEEMP/8QAFhEBAQEAAAAAAAAAAAAAAAAAAAER/9oACAEDAQE/EKYf/8QAFxEBAQEBAAAAAAAAAAAAAAAAAQAhYf/aAAgBAgEBPxAQbdL/xAAcEAEAAwACAwAAAAAAAAAAAAABABEhMUFhcYH/2gAIAQEAAT8QEKFnWherIJVAK3D7EqYKIotAAHzAFAFvl6jYL1oJ/9k=","aspectRatio":1.3266998341625207,"src":"/static/09d421399df2a0ed4dd800fe935768f9/381d6/pubblicazioni_hover.jpg","srcSet":"/static/09d421399df2a0ed4dd800fe935768f9/62f05/pubblicazioni_hover.jpg 200w,\n/static/09d421399df2a0ed4dd800fe935768f9/dc2b4/pubblicazioni_hover.jpg 400w,\n/static/09d421399df2a0ed4dd800fe935768f9/381d6/pubblicazioni_hover.jpg 800w","sizes":"(max-width: 800px) 100vw, 800px"}}},{"node":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAANABQDASIAAhEBAxEB/8QAFwAAAwEAAAAAAAAAAAAAAAAAAAMFBP/EABYBAQEBAAAAAAAAAAAAAAAAAAACA//aAAwDAQACEAMQAAAB1sgNxu2QQ//EABkQAAMBAQEAAAAAAAAAAAAAAAABAgMSEf/aAAgBAQABBQJPM7zO4FbFTHT9/8QAFREBAQAAAAAAAAAAAAAAAAAAABH/2gAIAQMBAT8Bqv/EABURAQEAAAAAAAAAAAAAAAAAAAAS/9oACAECAQE/AZS//8QAFhABAQEAAAAAAAAAAAAAAAAAADEg/9oACAEBAAY/AlXH/8QAGxAAAgEFAAAAAAAAAAAAAAAAAAEhETFBUWH/2gAIAQEAAT8hyGKlYcBsk9NizSf/2gAMAwEAAgADAAAAEFj/AP/EABURAQEAAAAAAAAAAAAAAAAAAAEQ/9oACAEDAQE/ECP/xAAVEQEBAAAAAAAAAAAAAAAAAAABEP/aAAgBAgEBPxBn/8QAGhABAAMBAQEAAAAAAAAAAAAAAQARMSFxwf/aAAgBAQABPxAeNutKyg8jjF8lRPkiugVeVDooeE//2Q==","aspectRatio":1.5711947626841243,"src":"/static/fe6d9a882f42ecf18d64d56f877cd699/381d6/progetto.jpg","srcSet":"/static/fe6d9a882f42ecf18d64d56f877cd699/62f05/progetto.jpg 200w,\n/static/fe6d9a882f42ecf18d64d56f877cd699/dc2b4/progetto.jpg 400w,\n/static/fe6d9a882f42ecf18d64d56f877cd699/381d6/progetto.jpg 800w,\n/static/fe6d9a882f42ecf18d64d56f877cd699/e5d70/progetto.jpg 1200w,\n/static/fe6d9a882f42ecf18d64d56f877cd699/d14e0/progetto.jpg 1600w,\n/static/fe6d9a882f42ecf18d64d56f877cd699/1971e/progetto.jpg 1920w","sizes":"(max-width: 800px) 100vw, 800px"}}},{"node":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAANABQDASIAAhEBAxEB/8QAFwAAAwEAAAAAAAAAAAAAAAAAAAMFBP/EABYBAQEBAAAAAAAAAAAAAAAAAAACA//aAAwDAQACEAMQAAAB1sgNxu2QQ//EABkQAAMBAQEAAAAAAAAAAAAAAAABAgMSEf/aAAgBAQABBQJPM7zO4FbFTHT9/8QAFREBAQAAAAAAAAAAAAAAAAAAABH/2gAIAQMBAT8Bqv/EABURAQEAAAAAAAAAAAAAAAAAAAAS/9oACAECAQE/AZS//8QAFhABAQEAAAAAAAAAAAAAAAAAADEg/9oACAEBAAY/AlXH/8QAGxAAAgEFAAAAAAAAAAAAAAAAAAEhETFBUWH/2gAIAQEAAT8hyGKlYcBsk9NizSf/2gAMAwEAAgADAAAAEFj/AP/EABURAQEAAAAAAAAAAAAAAAAAAAEQ/9oACAEDAQE/ECP/xAAVEQEBAAAAAAAAAAAAAAAAAAABEP/aAAgBAgEBPxBn/8QAGhABAAMBAQEAAAAAAAAAAAAAAQARMSFxwf/aAAgBAQABPxAeNutKyg8jjF8lRPkiugVeVDooeE//2Q==","aspectRatio":1.5711947626841243,"src":"/static/fe6d9a882f42ecf18d64d56f877cd699/381d6/progetto_base.jpg","srcSet":"/static/fe6d9a882f42ecf18d64d56f877cd699/62f05/progetto_base.jpg 200w,\n/static/fe6d9a882f42ecf18d64d56f877cd699/dc2b4/progetto_base.jpg 400w,\n/static/fe6d9a882f42ecf18d64d56f877cd699/381d6/progetto_base.jpg 800w,\n/static/fe6d9a882f42ecf18d64d56f877cd699/e5d70/progetto_base.jpg 1200w,\n/static/fe6d9a882f42ecf18d64d56f877cd699/d14e0/progetto_base.jpg 1600w,\n/static/fe6d9a882f42ecf18d64d56f877cd699/1971e/progetto_base.jpg 1920w","sizes":"(max-width: 800px) 100vw, 800px"}}},{"node":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAANABQDASIAAhEBAxEB/8QAFwAAAwEAAAAAAAAAAAAAAAAAAAMFBP/EABYBAQEBAAAAAAAAAAAAAAAAAAACA//aAAwDAQACEAMQAAAB1sgNxu2QQ//EABkQAAMBAQEAAAAAAAAAAAAAAAABAgMSEf/aAAgBAQABBQJPM7zO4FbFTHT9/8QAFREBAQAAAAAAAAAAAAAAAAAAABH/2gAIAQMBAT8Bqv/EABURAQEAAAAAAAAAAAAAAAAAAAAS/9oACAECAQE/AZS//8QAFhABAQEAAAAAAAAAAAAAAAAAADEg/9oACAEBAAY/AlXH/8QAGxAAAgEFAAAAAAAAAAAAAAAAAAEhETFBUWH/2gAIAQEAAT8hyGKlYcBsk9NizSf/2gAMAwEAAgADAAAAEFj/AP/EABURAQEAAAAAAAAAAAAAAAAAAAEQ/9oACAEDAQE/ECP/xAAVEQEBAAAAAAAAAAAAAAAAAAABEP/aAAgBAgEBPxBn/8QAGhABAAMBAQEAAAAAAAAAAAAAAQARMSFxwf/aAAgBAQABPxAeNutKyg8jjF8lRPkiugVeVDooeE//2Q==","aspectRatio":1.5711947626841243,"src":"/static/fe6d9a882f42ecf18d64d56f877cd699/381d6/progetto_hover.jpg","srcSet":"/static/fe6d9a882f42ecf18d64d56f877cd699/62f05/progetto_hover.jpg 200w,\n/static/fe6d9a882f42ecf18d64d56f877cd699/dc2b4/progetto_hover.jpg 400w,\n/static/fe6d9a882f42ecf18d64d56f877cd699/381d6/progetto_hover.jpg 800w,\n/static/fe6d9a882f42ecf18d64d56f877cd699/e5d70/progetto_hover.jpg 1200w,\n/static/fe6d9a882f42ecf18d64d56f877cd699/d14e0/progetto_hover.jpg 1600w,\n/static/fe6d9a882f42ecf18d64d56f877cd699/1971e/progetto_hover.jpg 1920w","sizes":"(max-width: 800px) 100vw, 800px"}}},{"node":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAPABQDASIAAhEBAxEB/8QAFwAAAwEAAAAAAAAAAAAAAAAAAAQFAv/EABYBAQEBAAAAAAAAAAAAAAAAAAECA//aAAwDAQACEAMQAAAB3QhMZU2RhP/EABkQAQADAQEAAAAAAAAAAAAAAAEAAgMSBP/aAAgBAQABBQLEBlvRQc3izs8z/8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAwEBPwE//8QAFxEAAwEAAAAAAAAAAAAAAAAAAAERIf/aAAgBAgEBPwFOGn//xAAaEAACAgMAAAAAAAAAAAAAAAAAARARIVGx/9oACAEBAAY/Asdiixrcf//EABoQAQEBAQADAAAAAAAAAAAAAAERACExQVH/2gAIAQEAAT8hnV08mCTJ+mfNdmU9Z1WIrd//2gAMAwEAAgADAAAAEAwf/8QAFhEBAQEAAAAAAAAAAAAAAAAAAQAR/9oACAEDAQE/EEGwv//EABcRAQADAAAAAAAAAAAAAAAAAAABESH/2gAIAQIBAT8Qkws//8QAGRABAAMBAQAAAAAAAAAAAAAAAQARMSGB/9oACAEBAAE/EFTUNCHmTsNFbLToqWleS0hwKM7GRwKLIjobP//Z","aspectRatio":1.3333333333333333,"src":"/static/a00f3ab5477ab7ebe1e8f73ce08bf875/381d6/home-evento.jpg","srcSet":"/static/a00f3ab5477ab7ebe1e8f73ce08bf875/62f05/home-evento.jpg 200w,\n/static/a00f3ab5477ab7ebe1e8f73ce08bf875/dc2b4/home-evento.jpg 400w,\n/static/a00f3ab5477ab7ebe1e8f73ce08bf875/381d6/home-evento.jpg 800w,\n/static/a00f3ab5477ab7ebe1e8f73ce08bf875/e5d70/home-evento.jpg 1200w,\n/static/a00f3ab5477ab7ebe1e8f73ce08bf875/d14e0/home-evento.jpg 1600w,\n/static/a00f3ab5477ab7ebe1e8f73ce08bf875/1971e/home-evento.jpg 1920w","sizes":"(max-width: 800px) 100vw, 800px"}}},{"node":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAZABQDASIAAhEBAxEB/8QAGAAAAwEBAAAAAAAAAAAAAAAAAAMEAQX/xAAWAQEBAQAAAAAAAAAAAAAAAAACAQP/2gAMAwEAAhADEAAAAVvmzJtAN59MtSjRYV//xAAcEAACAgMBAQAAAAAAAAAAAAABAgARAxIxEyL/2gAIAQEAAQUCwyp5hoDTlthjrSzF+QjkCYut3//EABYRAQEBAAAAAAAAAAAAAAAAABABEf/aAAgBAwEBPwHCH//EABYRAQEBAAAAAAAAAAAAAAAAABABEf/aAAgBAgEBPwHSn//EABsQAAIDAAMAAAAAAAAAAAAAABARAAIhATFx/9oACAEBAAY/AuaBuZFOmPcNh//EAB0QAQACAgIDAAAAAAAAAAAAAAEAESExQWFRkaH/2gAIAQEAAT8hAWPZE7wTRGNd4e41DTdwgFuxM25mVawqrQ3OCfETbP/aAAwDAQACAAMAAAAQo+18/8QAFxEAAwEAAAAAAAAAAAAAAAAAAAEQEf/aAAgBAwEBPxB0w//EABcRAQEBAQAAAAAAAAAAAAAAAAEAIRH/2gAIAQIBAT8QFK9sljf/xAAfEAEAAgICAgMAAAAAAAAAAAABABEhQTFREKFx0fD/2gAIAQEAAT8QpIMu/Gw/bmcqDnqDmqWil18QJVhWaHUTE3rG6x9wFFLKLghL4t4rncyRFU3gvIxEIFYMfUeFe9P/2Q==","aspectRatio":0.8020833333333334,"src":"/static/d7f98e5aa602070e7d84679cec8e3d2c/381d6/splash.jpg","srcSet":"/static/d7f98e5aa602070e7d84679cec8e3d2c/62f05/splash.jpg 200w,\n/static/d7f98e5aa602070e7d84679cec8e3d2c/dc2b4/splash.jpg 400w,\n/static/d7f98e5aa602070e7d84679cec8e3d2c/381d6/splash.jpg 800w,\n/static/d7f98e5aa602070e7d84679cec8e3d2c/e5d70/splash.jpg 1200w,\n/static/d7f98e5aa602070e7d84679cec8e3d2c/d99e3/splash.jpg 1540w","sizes":"(max-width: 800px) 100vw, 800px"}}},{"node":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAOABQDASIAAhEBAxEB/8QAFwABAQEBAAAAAAAAAAAAAAAAAAUBBP/EABUBAQEAAAAAAAAAAAAAAAAAAAIB/9oADAMBAAIQAxAAAAGmnYL3pJn/xAAaEAACAwEBAAAAAAAAAAAAAAAAEQECEgMU/9oACAEBAAEFAkZMwUlzfsj1I//EABURAQEAAAAAAAAAAAAAAAAAAAAS/9oACAEDAQE/AZS//8QAFhEBAQEAAAAAAAAAAAAAAAAAABIT/9oACAECAQE/AdFv/8QAGhAAAgIDAAAAAAAAAAAAAAAAAAIBQRAhkf/aAAgBAQAGPwLOmYuS+n//xAAcEAEAAgEFAAAAAAAAAAAAAAABABEQITFBcYH/2gAIAQEAAT8hrKYkR9c2KlzFaAfcf//aAAwDAQACAAMAAAAQqw//xAAWEQEBAQAAAAAAAAAAAAAAAAAAARH/2gAIAQMBAT8Qrh//xAAVEQEBAAAAAAAAAAAAAAAAAAABAP/aAAgBAgEBPxARDv/EABsQAQEBAAIDAAAAAAAAAAAAAAERACExQXGx/9oACAEBAAE/ECEZmeac4oq9iGuZM4S4L6yMYeQvzf/Z","aspectRatio":1.3862815884476534,"src":"/static/7c59b7b7056f0ed9f722b4d76a452390/381d6/gruppo-di-ricerca_base.jpg","srcSet":"/static/7c59b7b7056f0ed9f722b4d76a452390/62f05/gruppo-di-ricerca_base.jpg 200w,\n/static/7c59b7b7056f0ed9f722b4d76a452390/dc2b4/gruppo-di-ricerca_base.jpg 400w,\n/static/7c59b7b7056f0ed9f722b4d76a452390/381d6/gruppo-di-ricerca_base.jpg 800w,\n/static/7c59b7b7056f0ed9f722b4d76a452390/e5d70/gruppo-di-ricerca_base.jpg 1200w,\n/static/7c59b7b7056f0ed9f722b4d76a452390/d14e0/gruppo-di-ricerca_base.jpg 1600w,\n/static/7c59b7b7056f0ed9f722b4d76a452390/1971e/gruppo-di-ricerca_base.jpg 1920w","sizes":"(max-width: 800px) 100vw, 800px"}}},{"node":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAOABQDASIAAhEBAxEB/8QAFwABAQEBAAAAAAAAAAAAAAAAAAUBBP/EABUBAQEAAAAAAAAAAAAAAAAAAAIB/9oADAMBAAIQAxAAAAGmnYL3pJn/xAAaEAACAwEBAAAAAAAAAAAAAAAAEQECEgMU/9oACAEBAAEFAkZMwUlzfsj1I//EABURAQEAAAAAAAAAAAAAAAAAAAAS/9oACAEDAQE/AZS//8QAFhEBAQEAAAAAAAAAAAAAAAAAABIT/9oACAECAQE/AdFv/8QAGhAAAgIDAAAAAAAAAAAAAAAAAAIBQRAhkf/aAAgBAQAGPwLOmYuS+n//xAAcEAEAAgEFAAAAAAAAAAAAAAABABEQITFBcYH/2gAIAQEAAT8hrKYkR9c2KlzFaAfcf//aAAwDAQACAAMAAAAQqw//xAAWEQEBAQAAAAAAAAAAAAAAAAAAARH/2gAIAQMBAT8Qrh//xAAVEQEBAAAAAAAAAAAAAAAAAAABAP/aAAgBAgEBPxARDv/EABsQAQEBAAIDAAAAAAAAAAAAAAERACExQXGx/9oACAEBAAE/ECEZmeac4oq9iGuZM4S4L6yMYeQvzf/Z","aspectRatio":1.3862815884476534,"src":"/static/7c59b7b7056f0ed9f722b4d76a452390/381d6/gruppo-di-ricerca_hover.jpg","srcSet":"/static/7c59b7b7056f0ed9f722b4d76a452390/62f05/gruppo-di-ricerca_hover.jpg 200w,\n/static/7c59b7b7056f0ed9f722b4d76a452390/dc2b4/gruppo-di-ricerca_hover.jpg 400w,\n/static/7c59b7b7056f0ed9f722b4d76a452390/381d6/gruppo-di-ricerca_hover.jpg 800w,\n/static/7c59b7b7056f0ed9f722b4d76a452390/e5d70/gruppo-di-ricerca_hover.jpg 1200w,\n/static/7c59b7b7056f0ed9f722b4d76a452390/d14e0/gruppo-di-ricerca_hover.jpg 1600w,\n/static/7c59b7b7056f0ed9f722b4d76a452390/1971e/gruppo-di-ricerca_hover.jpg 1920w","sizes":"(max-width: 800px) 100vw, 800px"}}},{"node":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAOABQDASIAAhEBAxEB/8QAFwABAQEBAAAAAAAAAAAAAAAAAAUBBP/EABUBAQEAAAAAAAAAAAAAAAAAAAIB/9oADAMBAAIQAxAAAAGmnYL3pJn/xAAaEAACAwEBAAAAAAAAAAAAAAAAEQECEgMU/9oACAEBAAEFAkZMwUlzfsj1I//EABURAQEAAAAAAAAAAAAAAAAAAAAS/9oACAEDAQE/AZS//8QAFhEBAQEAAAAAAAAAAAAAAAAAABIT/9oACAECAQE/AdFv/8QAGhAAAgIDAAAAAAAAAAAAAAAAAAIBQRAhkf/aAAgBAQAGPwLOmYuS+n//xAAcEAEAAgEFAAAAAAAAAAAAAAABABEQITFBcYH/2gAIAQEAAT8hrKYkR9c2KlzFaAfcf//aAAwDAQACAAMAAAAQqw//xAAWEQEBAQAAAAAAAAAAAAAAAAAAARH/2gAIAQMBAT8Qrh//xAAVEQEBAAAAAAAAAAAAAAAAAAABAP/aAAgBAgEBPxARDv/EABsQAQEBAAIDAAAAAAAAAAAAAAERACExQXGx/9oACAEBAAE/ECEZmeac4oq9iGuZM4S4L6yMYeQvzf/Z","aspectRatio":1.3862815884476534,"src":"/static/7c59b7b7056f0ed9f722b4d76a452390/381d6/veduta-di-milano.jpg","srcSet":"/static/7c59b7b7056f0ed9f722b4d76a452390/62f05/veduta-di-milano.jpg 200w,\n/static/7c59b7b7056f0ed9f722b4d76a452390/dc2b4/veduta-di-milano.jpg 400w,\n/static/7c59b7b7056f0ed9f722b4d76a452390/381d6/veduta-di-milano.jpg 800w,\n/static/7c59b7b7056f0ed9f722b4d76a452390/e5d70/veduta-di-milano.jpg 1200w,\n/static/7c59b7b7056f0ed9f722b4d76a452390/d14e0/veduta-di-milano.jpg 1600w,\n/static/7c59b7b7056f0ed9f722b4d76a452390/1971e/veduta-di-milano.jpg 1920w","sizes":"(max-width: 800px) 100vw, 800px"}}},{"node":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAOABQDASIAAhEBAxEB/8QAFgABAQEAAAAAAAAAAAAAAAAABQAB/8QAFQEBAQAAAAAAAAAAAAAAAAAAAgH/2gAMAwEAAhADEAAAAU43BUYeZ//EABoQAAIDAQEAAAAAAAAAAAAAAAARAQISAxT/2gAIAQEAAQUCRkyUlzfsj1I//8QAFREBAQAAAAAAAAAAAAAAAAAAABL/2gAIAQMBAT8BlL//xAAWEQEBAQAAAAAAAAAAAAAAAAAAEgH/2gAIAQIBAT8Btev/xAAbEAACAQUAAAAAAAAAAAAAAAAAAiEBEBFBkf/aAAgBAQAGPwK8Oxiam+n/xAAaEAADAQADAAAAAAAAAAAAAAAAAREhMUFx/9oACAEBAAE/ITBA6mnmstpq7Kwk/o//2gAMAwEAAgADAAAAEPsP/8QAFhEBAQEAAAAAAAAAAAAAAAAAAAER/9oACAEDAQE/EK4f/8QAFREBAQAAAAAAAAAAAAAAAAAAAQD/2gAIAQIBAT8QHEf/xAAZEAEBAQEBAQAAAAAAAAAAAAABEQBBcbH/2gAIAQEAAT8QBOZw9zJDOBNciRhLhfMrnDoX5v/Z","aspectRatio":1.3866666666666667,"src":"/static/0e332dccf4bea785f80764dbc257dd49/381d6/sottoprogetti.jpg","srcSet":"/static/0e332dccf4bea785f80764dbc257dd49/62f05/sottoprogetti.jpg 200w,\n/static/0e332dccf4bea785f80764dbc257dd49/dc2b4/sottoprogetti.jpg 400w,\n/static/0e332dccf4bea785f80764dbc257dd49/381d6/sottoprogetti.jpg 800w,\n/static/0e332dccf4bea785f80764dbc257dd49/e5d70/sottoprogetti.jpg 1200w,\n/static/0e332dccf4bea785f80764dbc257dd49/d14e0/sottoprogetti.jpg 1600w,\n/static/0e332dccf4bea785f80764dbc257dd49/9e67f/sottoprogetti.jpg 2400w,\n/static/0e332dccf4bea785f80764dbc257dd49/f07fd/sottoprogetti.jpg 3432w","sizes":"(max-width: 800px) 100vw, 800px"}}},{"node":{"sizes":{"base64":"data:image/webp;base64,UklGRqIAAABXRUJQVlA4WAoAAAAQAAAAEwAABQAAQUxQSFcAAAABcBjbtumcb8a2bdu21UUqyG8lFaRKlhARif+ci9ZyMZrofGav2ymBIACU7sojxszz2VatNbDiLa+8njJamXA21IyUC0k3APP5thPgcVcbvnq110zH8CcAVlA4ICQAAACwAgCdASoUAAYAPm0skUWkIqGYBABABsS0gAA9kAAA/vucwAA=","aspectRatio":3.2454212454212454,"src":"/static/b0dddf7520b3c8a0d7b1494e733800f3/2b3dc/footer-adm.webp","srcSet":"/static/b0dddf7520b3c8a0d7b1494e733800f3/45824/footer-adm.webp 200w,\n/static/b0dddf7520b3c8a0d7b1494e733800f3/d9d2e/footer-adm.webp 400w,\n/static/b0dddf7520b3c8a0d7b1494e733800f3/2b3dc/footer-adm.webp 800w,\n/static/b0dddf7520b3c8a0d7b1494e733800f3/4aeab/footer-adm.webp 1200w,\n/static/b0dddf7520b3c8a0d7b1494e733800f3/4bd95/footer-adm.webp 1600w,\n/static/b0dddf7520b3c8a0d7b1494e733800f3/4fc42/footer-adm.webp 1772w","sizes":"(max-width: 800px) 100vw, 800px"}}},{"node":{"sizes":{"base64":"data:image/webp;base64,UklGRg4BAABXRUJQVlA4WAoAAAAQAAAAEwAABgAAQUxQSIUAAAAFcFtr25r8f9w9aTnUoXYZgAGoaZmIGRjFKipK7eKeYNEhImICdsp+YAb8poAlgCXo7Lm3yyo3F6ATlq1t6fa1T2bB3xunfAe07wBflu8fSv4Twri+8B8BXVjSw69sUzAhPbVk04ClzyUgZkhREj8sLCmEPgSgTa+BK0VM6fKk89PId4QCAFZQOCBiAAAAcAMAnQEqFAAHAD5tLJJFpCKhmAQAQAbEsgBOmUI4ABLO1erAAP6t0w2WwfaSDidi+NXnATbeOOit/tGUW27t4AEXY0Gd5dH/Ryy2sbxu0f6nIfLn/8nIEVBiFFn3iNMAAAA=","aspectRatio":2.9557266602502406,"src":"/static/eff5e95269dcdf9499e0b0e943ab048e/2b3dc/footer-centraleFns.webp","srcSet":"/static/eff5e95269dcdf9499e0b0e943ab048e/45824/footer-centraleFns.webp 200w,\n/static/eff5e95269dcdf9499e0b0e943ab048e/d9d2e/footer-centraleFns.webp 400w,\n/static/eff5e95269dcdf9499e0b0e943ab048e/2b3dc/footer-centraleFns.webp 800w,\n/static/eff5e95269dcdf9499e0b0e943ab048e/4aeab/footer-centraleFns.webp 1200w,\n/static/eff5e95269dcdf9499e0b0e943ab048e/4bd95/footer-centraleFns.webp 1600w,\n/static/eff5e95269dcdf9499e0b0e943ab048e/743e2/footer-centraleFns.webp 2400w,\n/static/eff5e95269dcdf9499e0b0e943ab048e/0b11d/footer-centraleFns.webp 3071w","sizes":"(max-width: 800px) 100vw, 800px"}}},{"node":{"sizes":{"base64":"data:image/webp;base64,UklGRkoBAABXRUJQVlA4WAoAAAAQAAAAEwAABwAAQUxQSJEAAAANgCPbtqpo4+7uTkRExiwIGaqFTujutLt7P3QQEZEcJbCVSNiy5UQR+llvge0WkP1LtkC4NMuZXOaPV5tccuf/Vpnz1/y9fzoy00ud/10M0j2LdawF8a74Wyil20/rINnSploXclA6lVdhg+ot3vfceRSNcPMPVtmAvPwp0VxbpcLyonqS/8FPHz7Yci/gEgEAAFZQOCCSAAAAcAQAnQEqFAAIAD5tKpFFpCKhmAQAQAbEtABOmUI4F+AjQDeSQMyDQGYgv4AA/vlWlPvqOt2Ls/RWrJ5wSOV1VNmxVP7sTm0B//OLeqUcb65eDQLLP/7xcLc2MmRaHmUc49aDM3Q3/wZSad7dWr+YhzpAeb1aUm/Jp/z2OR/5NYe6Y5WJ6/Xrn4UfiLPnjj+AAAA=","aspectRatio":2.5337620578778135,"src":"/static/a9ce4359cee5e83f91a67127a3ab958e/2b3dc/footer-innsbruck.webp","srcSet":"/static/a9ce4359cee5e83f91a67127a3ab958e/45824/footer-innsbruck.webp 200w,\n/static/a9ce4359cee5e83f91a67127a3ab958e/d9d2e/footer-innsbruck.webp 400w,\n/static/a9ce4359cee5e83f91a67127a3ab958e/2b3dc/footer-innsbruck.webp 800w,\n/static/a9ce4359cee5e83f91a67127a3ab958e/4aeab/footer-innsbruck.webp 1200w,\n/static/a9ce4359cee5e83f91a67127a3ab958e/4bd95/footer-innsbruck.webp 1600w,\n/static/a9ce4359cee5e83f91a67127a3ab958e/b4b63/footer-innsbruck.webp 2364w","sizes":"(max-width: 800px) 100vw, 800px"}}},{"node":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAUABQDASIAAhEBAxEB/8QAFwABAQEBAAAAAAAAAAAAAAAAAAQBA//EABgBAAMBAQAAAAAAAAAAAAAAAAABAwIE/9oADAMBAAIQAxAAAAG7nLj6u6Y6AUwGf//EABsQAAIBBQAAAAAAAAAAAAAAAAABAhASEyAx/9oACAEBAAEFAr4jmZXou0//xAAZEQABBQAAAAAAAAAAAAAAAAACAAEDEBP/2gAIAQMBAT8BaIVmN//EABURAQEAAAAAAAAAAAAAAAAAABEg/9oACAECAQE/ASP/xAAZEAABBQAAAAAAAAAAAAAAAAAAECAhQWH/2gAIAQEABj8CIKTW/wD/xAAdEAABBAIDAAAAAAAAAAAAAAABABEhMWGhEEGB/9oACAEBAAE/IXmnRTbXPdrBuhLzKMUfSJPBblPgL//aAAwDAQACAAMAAAAQHxi//8QAGBEBAQADAAAAAAAAAAAAAAAAAAExQWH/2gAIAQMBAT8Qirk2uX//xAAXEQADAQAAAAAAAAAAAAAAAAAAAREQ/9oACAECAQE/EIIt/8QAHBABAAMAAgMAAAAAAAAAAAAAAQARIUFhMVGh/9oACAEBAAE/EBSPPN6IBBL7Ceh3EmlXmBXBekT9jhBugzLemK2FvdhXLJ//2Q==","aspectRatio":0.9841897233201581,"src":"/static/3804505891b01931eb159cdf642f608e/b1bd6/footer-lugerna.jpg","srcSet":"/static/3804505891b01931eb159cdf642f608e/6b66e/footer-lugerna.jpg 200w,\n/static/3804505891b01931eb159cdf642f608e/b1bd6/footer-lugerna.jpg 249w","sizes":"(max-width: 249px) 100vw, 249px"}}},{"node":{"sizes":{"base64":"data:image/webp;base64,UklGRkICAABXRUJQVlA4WAoAAAAQAAAAEwAAKwAAQUxQSMQBAAABoHTbtmm9mvuc2LZt27Zt2zaqtm39ANuqpWzbzr1n7xFcJXmvHhETIEm+lKZim3bVMkqeIhqpxIaHAM93VZGMJCNND4Oz1gJ7M8lI0noIWecs98ZPW1hPkq+ZhCzOYXk4bPSIFt08qZTF4gBHuNvz1ena1ZU2EcIBBOyv/THjhT79Uqd9RODAWRdma/cLOei6vFZlHDgHWN7V0oKbGV71bkv4xVf48sJheXedl5cZ14aXWffDppyfcBYsMKESL7QFlukjFhs4953OaZ6/03ZYmeQ3cI5QUW0Payss9yM4wpyWyj3Tbljn/eZwAS3laUymsTAgxTecw31nszxJKVSuqOYTOBuyHDIykpSvx8Rj2ABghWQUsdbBtwHwbG81ySh68kqtWtfIIPlGUT1fEX1PcRqj6IWvXr1yNfbLN2qXI4HtEpO6bq1aderWqVO7Zt369SI2zCSlSSJJSdIr1mLTxw6dN37M+IWdlMSLKCUrmK5I5iyZsubMoBiLzhk3v5tRnFlrFihdVJJMLCWndevffkKf4ekUa/rKpWuUqVy4ZqqY8vVrOaBR84aKPVvnjt06tu+QOrYEG+MZY+L5v/Yzxp8pKVZQOCBYAAAAcAMAnQEqFAAsAD5tMpRHJCMiISqoAIANiWkAAD2QBmUDnLwAAP78RCrVPO1SlxPM1MEFWrI6cEIlytN/pR4DSoCYsISYQhE7CROSiIBTQG/q1p//wWAAAA==","aspectRatio":0.4505363528009535,"src":"/static/f85ea065fc0b67bb111368f2fe79addc/8541f/footer-usi.webp","srcSet":"/static/f85ea065fc0b67bb111368f2fe79addc/f621f/footer-usi.webp 200w,\n/static/f85ea065fc0b67bb111368f2fe79addc/8541f/footer-usi.webp 378w","sizes":"(max-width: 378px) 100vw, 378px"}}},{"node":{"sizes":{"base64":"data:image/webp;base64,UklGRpQDAABXRUJQVlA4WAoAAAAQAAAAEwAAIAAAQUxQSLsBAAABkGzbtmk7c9/7bNu234tt27btWlrKdj0/4KSa9kqxfsC2efaeM7r4hIiYAAB+YNzJe5bPTs2Lg8G/BoNuKeD9OYABfNgoWc+R9DzpGGD8WC96/L+spxMw6CE5kZJEip4WAt3yRAWkrJ4k9ZMjFST1S8v3yQvF6sJlWSpoOj17IoYgyj4Lh7slFwKdXp+QRwZndWmMbHDUL201d2XFQJTTx1yMlaXI/1D8qR3wYa88K5Ii5X7qPP49Iv2yjnT2l3QxGgYGWPJSAb/tBnwAYJC+qfv112/vru8pBQz+6weQXFWTAcCPwCYC/43wwZgAIcaYVCQnIiHXRJenFMenZ6bWFtQkzkDvFUlt20s75hTMnbkwZfjk+mF9F6FH+6wBE2e1z87a36t21tj+rSOWD2ytQEff8oH5g8raezT1qK/vRM/2ftH9M6dW9BvaOqC6KrOyclBCZ/YOJOyqHBfROm4y5s/OmLAOWDxha2L7gGmTI3uMnJQ1c3bN2OUldZ1rinqlobgRiQnprcmF/TOT2gqR06tHY++cjpymwobypJrCxNLC6s6mZVOH9UkaP2lD1+BRdZ0tvZcOmDpqAABWUDggsgEAABAKAJ0BKhQAIQA+bSiSRaQiIZgNVVRABsS2AF2X4/znewjGiEBygHqA8WD9ZssA58D2MvKMicHuz4CUv0VtOeD/xTZiEfeEOyccYkkZ4ohX/me6E3HFRbYAAP7J2qjiy/Wttk4p3FvUZxzBdPYM/FuQPdFoiMEZI13aqC/orcD9zX8UBGAe7gSnJZeGf4hz6f6lQ6uVftNY75e7H8Gy0rETMBkwlPkmC/M+I9Mfz37Zp9gXuKD7cNAadi7nFf/v7Wu3+2Gor4MmgvaImge7ej/8tu92xbqJXfTFo5/5lH9NdwS+IqUiUTorA2ua8YTGfPmmafhICifx4JHx72hFNe6H34yo4irZ/RoJjt2lbw/7M/9j5zVHT/8ZbO6vtRGHcjTZ+3ehUduDjXMdp7aqYZmocFFKDzmHD76GQizdgShnSOKDcjRiIUBgC8GIzrEKMN2fr9A8CAUuHH48eZ74ImU+BQj8xSpf+LoLlBvVFZ/99KrJ4Cbu5M31x+nKjuAUl/B9ZcUD/IZHPAL3lIXynefXY1PKIGe19d96roKIKyRAFn+TiFoFLf5BWLkFr7AAAAAA","aspectRatio":0.6106346483704974,"src":"/static/e9d5ed039054d065e6c704509de71e54/e5b32/footer-cattolica.webp","srcSet":"/static/e9d5ed039054d065e6c704509de71e54/c960f/footer-cattolica.webp 200w,\n/static/e9d5ed039054d065e6c704509de71e54/b750e/footer-cattolica.webp 400w,\n/static/e9d5ed039054d065e6c704509de71e54/e5b32/footer-cattolica.webp 712w","sizes":"(max-width: 712px) 100vw, 712px"}}},{"node":{"sizes":{"base64":"data:image/webp;base64,UklGRsABAABXRUJQVlA4WAoAAAAQAAAAEwAAEQAAQUxQSCoBAAAJkGzbtmlXc584J8227ZRsO2UbVdu2+Vizbdu2bV/j7MfzDRExAW90laAEjDLgKaH4ty6rq6unq6ujy4AnByq5K1CCUj7yjSuOzh5Yv/qrKq8nHx4aPX39UMTwgR5LZNAyIuBLCEAJiArlo86pMXJOTalBwIAABIDk89cPu558//JFBiUoQAF4DXUuft/aMpHwBVYwYGEF4IvAer3NsijptmXYbbKmJmgVCNTQ/vDygbrAb6Zm17ItPbPOgwGFyQPc1SgQ6qbtaDoozToACg5LFeV918OOHi+9bXbyo9NpUMJhd6VLb0/rSNXIq8wjM8kUlAJWstXXzR5HhFx3e2jh9jI6KCgAEFA9e2P2p8BEbqwhNBVyAo7A0FGobmVtb25gbOXDCi9cuHUdVlA4IHAAAAAwBACdASoUABIAPm0wlUakIqIhKAqogA2JZAB2AGoAev/ZKAD45yug1AAA/vCFD//8s/kB8mMoxmf4u9Tn//zBOsao1v15nfnz4WrXttxO2ZVK/Tv6cIN7wcoxKG05Mk+3YbKe0J4oBrieElQLKwAA","aspectRatio":1.098901098901099,"src":"/static/15a1fe3c15ba2a5b490c959284add9ba/2b3dc/footer-oaw.webp","srcSet":"/static/15a1fe3c15ba2a5b490c959284add9ba/45824/footer-oaw.webp 200w,\n/static/15a1fe3c15ba2a5b490c959284add9ba/d9d2e/footer-oaw.webp 400w,\n/static/15a1fe3c15ba2a5b490c959284add9ba/2b3dc/footer-oaw.webp 800w,\n/static/15a1fe3c15ba2a5b490c959284add9ba/4aeab/footer-oaw.webp 1200w,\n/static/15a1fe3c15ba2a5b490c959284add9ba/4bd95/footer-oaw.webp 1600w,\n/static/15a1fe3c15ba2a5b490c959284add9ba/ed430/footer-oaw.webp 2000w","sizes":"(max-width: 800px) 100vw, 800px"}}},{"node":{"sizes":{"base64":"data:image/webp;base64,UklGRlgBAABXRUJQVlA4WAoAAAAQAAAAEwAACAAAQUxQSJcAAAANgFvbtmplnfe+u/9IG/ghoUNETAFUQi2eQglkbpG7u7vcc7AiImICEAMBE/4agGijd3YGsH/+tfoYLQPXhY2Ge0x96smuGPRwn+4bLBf2U9Hzd49/J5sNxivHxafnyjKAgWz0t04Run0PeMexkIbU/3wxWZmAjph9ePLhu+jN4cclJr7qnIb0w3OEb2L8NQc37waGUxAMAFZQOCCaAAAAsAQAnQEqFAAJAD5tLJJFpCKhmAQAQAbEoAnTKDGCZ/xaxjJj81hf7THqA/+1MAD2ucouEP8x696226v11jlQT2fxWdQPz5nK4wC/J8J9k9j/5fqoGF6t6o4yVdLUa4tfKh/8rJ0zT8D/+9u0QcLeKPTRecOTwg6b+lhSc4MT9DzTYrgDxKDX2qlNeGxvKH5OqSk9Tcnm2RTwAA==","aspectRatio":2.166137566137566,"src":"/static/cd2d3f26937f4b8956f499cd5cac8a71/2b3dc/footer-politecnico.webp","srcSet":"/static/cd2d3f26937f4b8956f499cd5cac8a71/45824/footer-politecnico.webp 200w,\n/static/cd2d3f26937f4b8956f499cd5cac8a71/d9d2e/footer-politecnico.webp 400w,\n/static/cd2d3f26937f4b8956f499cd5cac8a71/2b3dc/footer-politecnico.webp 800w,\n/static/cd2d3f26937f4b8956f499cd5cac8a71/4aeab/footer-politecnico.webp 1200w,\n/static/cd2d3f26937f4b8956f499cd5cac8a71/4bd95/footer-politecnico.webp 1600w,\n/static/cd2d3f26937f4b8956f499cd5cac8a71/1a0b5/footer-politecnico.webp 2047w","sizes":"(max-width: 800px) 100vw, 800px"}}},{"node":{"sizes":{"base64":"data:image/webp;base64,UklGRiIBAABXRUJQVlA4WAoAAAAQAAAAEwAACAAAQUxQSGYAAAAFcB3btpqcJ3FPcOiDJmiDjqiFX4pxd5e4dhARE4Aqqd/zF9QvAIykIfIrFHJfmvj/7yfF+geKKft0xjU9eBwJ/nc+cA/0Z+O1lVmzvrsE7nT8V5UXsdXAf3PKxefal37XAJUTBAlWUDgglgAAAJAEAJ0BKhQACQA+bSqSRaQioZgEAEAGxLUATplBjBwgA8+SBr/J/ZlbkuLlEAD+8rG6bBYVbAuF3F4cRBhWCy9qXgF86RrrbJOjGqxwEnfWT+PjF/sti1iZsGZbZekX/n/mUd2HPYuEP33sY/8XiWcS7VIZbWO87UfYF4/sRQbVOQq22DtmUmLp16NS7rA3naM9WwAAAA==","aspectRatio":2.2189349112426036,"src":"/static/17ddaa5de7483c3ce40359b810ac956d/2b3dc/footer-sorbonne.webp","srcSet":"/static/17ddaa5de7483c3ce40359b810ac956d/45824/footer-sorbonne.webp 200w,\n/static/17ddaa5de7483c3ce40359b810ac956d/d9d2e/footer-sorbonne.webp 400w,\n/static/17ddaa5de7483c3ce40359b810ac956d/2b3dc/footer-sorbonne.webp 800w,\n/static/17ddaa5de7483c3ce40359b810ac956d/4aeab/footer-sorbonne.webp 1200w,\n/static/17ddaa5de7483c3ce40359b810ac956d/4bd95/footer-sorbonne.webp 1600w,\n/static/17ddaa5de7483c3ce40359b810ac956d/743e2/footer-sorbonne.webp 2400w,\n/static/17ddaa5de7483c3ce40359b810ac956d/52bbb/footer-sorbonne.webp 3000w","sizes":"(max-width: 800px) 100vw, 800px"}}},{"node":{"sizes":{"base64":"data:image/webp;base64,UklGRiABAABXRUJQVlA4WAoAAAAQAAAAEwAABwAAQUxQSHMAAAAFcBsADNIkuDsTtLu3Z/TkPuI6urulmYAXIkJh0gZM0vELZPTbPFhDgWpVl1+9WwFBZdncj/MOgUHo0NvrvpCREXIsyzPI2NLJFO+HWNl8PASiYBXwXEaU3n9F+n4kBAaZmK/lBB8/93WShZ8sXU1J3i4AAFZQOCCGAAAAMAQAnQEqFAAIAD5tLJJFpCKhmAQAQAbEoAnTKEdxX4AC4eTxAHA8xmyAAP0eDf1+zjsx3PqFq6iddcQPxDJZhsqqO5COHuKEkzLANRZDyRn88SrWKaWOeUVIwRZG88IbpbsK9q28IyQWCeV4fymH/GPBO5/jGvliurf+yCQhj+j+vsjgAAA=","aspectRatio":2.522727272727273,"src":"/static/a932021438ae2ef3152e271f47db9bd3/2b3dc/footer-uniMilano.webp","srcSet":"/static/a932021438ae2ef3152e271f47db9bd3/45824/footer-uniMilano.webp 200w,\n/static/a932021438ae2ef3152e271f47db9bd3/d9d2e/footer-uniMilano.webp 400w,\n/static/a932021438ae2ef3152e271f47db9bd3/2b3dc/footer-uniMilano.webp 800w,\n/static/a932021438ae2ef3152e271f47db9bd3/1db7a/footer-uniMilano.webp 1110w","sizes":"(max-width: 800px) 100vw, 800px"}}}]}},"layoutContext":{}}

/***/ }),

/***/ 288:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(300);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(172);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 139:
/***/ (function(module, exports, __webpack_require__) {

	(function() {
	  'use strict';
	
	  // desiredOffset - page offset to scroll to
	  // speed - duration of the scroll per 1000px
	  function __ANIMATE_SCROLL_TO(desiredOffset) {
	    var userOptions = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	    var options = {
	      speed: 500,
	      minDuration: 250,
	      maxDuration: 1500,
	      cancelOnUserAction: true,
	      element: window,
	      horizontal: false,
	      onComplete: undefined,
	      passive: true,
	      offset: 0
	    };
	
	    var optionsKeys = Object.keys(options);
	
	    // Override default options
	    for (var i = 0; i < optionsKeys.length; i++) {
	      var key = optionsKeys[i];
	
	      if (typeof userOptions[key] !== 'undefined') {
	        options[key] = userOptions[key];
	      }
	    }
	
	    if (!options.cancelOnUserAction && options.passive) {
	      options.passive = false;
	      if (userOptions.passive) {
	        console && console.warn(
	          'animated-scroll-to:\n "passive" was set to "false" to prevent errors, ' +
	          'as using "cancelOnUserAction: false" doesn\'t work with passive events.')
	      }
	    }
	
	    if (desiredOffset instanceof HTMLElement) {
	      if (userOptions.element && userOptions.element instanceof HTMLElement) {
	        if (options.horizontal) {
	          desiredOffset = (desiredOffset.getBoundingClientRect().left + userOptions.element.scrollLeft)
	            - userOptions.element.getBoundingClientRect().left;
	        } else {
	          desiredOffset = (desiredOffset.getBoundingClientRect().top + userOptions.element.scrollTop)
	            - userOptions.element.getBoundingClientRect().top;
	        }
	      } else if (options.horizontal) {
	        var scrollLeft = window.scrollX || document.documentElement.scrollLeft;
	        desiredOffset = scrollLeft + desiredOffset.getBoundingClientRect().left;
	      } else {
	        var scrollTop = window.scrollY || document.documentElement.scrollTop;
	        desiredOffset = scrollTop + desiredOffset.getBoundingClientRect().top;
	      }
	    }
	
	    // Add additonal user offset
	    desiredOffset += options.offset
	
	    options.isWindow = options.element === window;
	
	    var initialScrollPosition = null;
	    var initialAxisScollPosition = 0;
	    var maxScroll = null;
	
	    if (options.isWindow) {
	      if (options.horizontal) {
	        // get cross browser scroll positions
	        initialScrollPosition = window.scrollX || document.documentElement.scrollLeft;
	        initialAxisScollPosition = window.scrollY || document.documentElement.scrollTop;
	        // cross browser document height minus window height
	        maxScroll = Math.max(
	          document.body.scrollWidth, document.documentElement.scrollWidth,
	          document.body.offsetWidth, document.documentElement.offsetWidth,
	          document.body.clientWidth, document.documentElement.clientWidth
	        ) - window.innerWidth;
	      } else {
	        // get cross browser scroll positions
	        initialScrollPosition = window.scrollY || document.documentElement.scrollTop;
	        initialAxisScollPosition = window.scrollX || document.documentElement.scrollLeft;
	        // cross browser document width minus window width
	        maxScroll = Math.max(
	          document.body.scrollHeight, document.documentElement.scrollHeight,
	          document.body.offsetHeight, document.documentElement.offsetHeight,
	          document.body.clientHeight, document.documentElement.clientHeight
	        ) - window.innerHeight;
	      }
	    } else {
	      // DOM element
	      if (options.horizontal) {
	        initialScrollPosition = options.element.scrollLeft;
	        maxScroll = options.element.scrollWidth - options.element.clientWidth;
	      } else {
	        initialScrollPosition = options.element.scrollTop;
	        maxScroll = options.element.scrollHeight - options.element.clientHeight;
	      }
	    }
	
	    // If the scroll position is greater than maximum available scroll
	    if (desiredOffset > maxScroll) {
	      desiredOffset = maxScroll;
	    }
	
	    // Calculate diff to scroll
	    var diff = desiredOffset - initialScrollPosition;
	
	    // Do nothing if the page is already there
	    if (diff === 0) {
	      // Execute callback if there is any
	      if (options.onComplete && typeof options.onComplete === 'function') {
	        options.onComplete()
	      }
	
	      return;
	    }
	
	    // Calculate duration of the scroll
	    var duration = Math.abs(Math.round((diff / 1000) * options.speed));
	
	    // Set minimum and maximum duration
	    if (duration < options.minDuration) {
	      duration = options.minDuration;
	    } else if (duration > options.maxDuration) {
	      duration = options.maxDuration;
	    }
	
	    var startingTime = Date.now();
	
	    // Request animation frame ID
	    var requestID = null;
	
	    // Method handler
	    var handleUserEvent = null;
	    var userEventOptions = { passive: options.passive };
	
	    if (options.cancelOnUserAction) {
	      // Set handler to cancel scroll on user action
	      handleUserEvent = function() {
	        removeListeners();
	        cancelAnimationFrame(requestID);
	      };
	      window.addEventListener('keydown', handleUserEvent, userEventOptions);
	      window.addEventListener('mousedown', handleUserEvent, userEventOptions);
	    } else {
	      // Set handler to prevent user actions while scroll is active
	      handleUserEvent = function(e) { e.preventDefault(); };
	      window.addEventListener('scroll', handleUserEvent, userEventOptions);
	    }
	
	    window.addEventListener('wheel', handleUserEvent, userEventOptions);
	    window.addEventListener('touchstart', handleUserEvent, userEventOptions);
	
	    var removeListeners = function () {
	      window.removeEventListener('wheel', handleUserEvent, userEventOptions);
	      window.removeEventListener('touchstart', handleUserEvent, userEventOptions);
	
	      if (options.cancelOnUserAction) {
	        window.removeEventListener('keydown', handleUserEvent, userEventOptions);
	        window.removeEventListener('mousedown', handleUserEvent, userEventOptions);
	      } else {
	        window.removeEventListener('scroll', handleUserEvent, userEventOptions);
	      }
	    };
	
	    var step = function () {
	      var timeDiff = Date.now() - startingTime;
	      var t = (timeDiff / duration) - 1;
	      var easing = t * t * t + 1;
	      var scrollPosition = Math.round(initialScrollPosition + (diff * easing));
	
	      var doScroll = function(position) {
	        if (options.isWindow) {
	          if (options.horizontal) {
	            options.element.scrollTo(position, initialAxisScollPosition);
	          } else {
	            options.element.scrollTo(initialAxisScollPosition, position);
	          }
	        } else if (options.horizontal) {
	          options.element.scrollLeft = position;
	        } else {
	          options.element.scrollTop = position;
	        }
	      }
	
	      if (timeDiff < duration && scrollPosition !== desiredOffset) {
	        // If scroll didn't reach desired offset or time is not elapsed
	        // Scroll to a new position
	        // And request a new step
	        doScroll(scrollPosition);
	
	        requestID = requestAnimationFrame(step);
	      } else {
	        // If the time elapsed or we reached the desired offset
	        // Set scroll to the desired offset (when rounding made it to be off a pixel or two)
	        // Clear animation frame to be sure
	        doScroll(desiredOffset);
	
	        cancelAnimationFrame(requestID);
	
	        // Remove listeners
	        removeListeners();
	
	        // Animation is complete, execute callback if there is any
	        if (options.onComplete && typeof options.onComplete === 'function') {
	          options.onComplete()
	        }
	      }
	    };
	
	    // Start animating scroll
	    requestID = requestAnimationFrame(step);
	  }
	
	  if (true) {
	    if (typeof module !== 'undefined' && module.exports) {
	      module.exports = __ANIMATE_SCROLL_TO;
	      exports = module.exports;
	    }
	    exports.default = __ANIMATE_SCROLL_TO;
	  } else if (window) {
	    window.animateScrollTo = __ANIMATE_SCROLL_TO;
	  }
	}).call(this);


/***/ }),

/***/ 202:
/***/ (function(module, exports, __webpack_require__) {

	var upperCase = __webpack_require__(37)
	var noCase = __webpack_require__(28)
	
	/**
	 * Camel case a string.
	 *
	 * @param  {string} value
	 * @param  {string} [locale]
	 * @return {string}
	 */
	module.exports = function (value, locale, mergeNumbers) {
	  var result = noCase(value, locale)
	
	  // Replace periods between numeric entities with an underscore.
	  if (!mergeNumbers) {
	    result = result.replace(/ (?=\d)/g, '_')
	  }
	
	  // Replace spaces between words with an upper cased character.
	  return result.replace(/ (.)/g, function (m, $1) {
	    return upperCase($1, locale)
	  })
	}


/***/ }),

/***/ 322:
/***/ (function(module, exports, __webpack_require__) {

	exports.no = exports.noCase = __webpack_require__(28)
	exports.dot = exports.dotCase = __webpack_require__(401)
	exports.swap = exports.swapCase = __webpack_require__(733)
	exports.path = exports.pathCase = __webpack_require__(610)
	exports.upper = exports.upperCase = __webpack_require__(37)
	exports.lower = exports.lowerCase = __webpack_require__(81)
	exports.camel = exports.camelCase = __webpack_require__(202)
	exports.snake = exports.snakeCase = __webpack_require__(279)
	exports.title = exports.titleCase = __webpack_require__(734)
	exports.param = exports.paramCase = __webpack_require__(608)
	exports.header = exports.headerCase = __webpack_require__(503)
	exports.pascal = exports.pascalCase = __webpack_require__(609)
	exports.constant = exports.constantCase = __webpack_require__(323)
	exports.sentence = exports.sentenceCase = __webpack_require__(730)
	exports.isUpper = exports.isUpperCase = __webpack_require__(522)
	exports.isLower = exports.isLowerCase = __webpack_require__(521)
	exports.ucFirst = exports.upperCaseFirst = __webpack_require__(196)
	exports.lcFirst = exports.lowerCaseFirst = __webpack_require__(587)


/***/ }),

/***/ 323:
/***/ (function(module, exports, __webpack_require__) {

	var upperCase = __webpack_require__(37)
	var snakeCase = __webpack_require__(279)
	
	/**
	 * Constant case a string.
	 *
	 * @param  {string} value
	 * @param  {string} [locale]
	 * @return {string}
	 */
	module.exports = function (value, locale) {
	  return upperCase(snakeCase(value, locale), locale)
	}


/***/ }),

/***/ 401:
/***/ (function(module, exports, __webpack_require__) {

	var noCase = __webpack_require__(28)
	
	/**
	 * Dot case a string.
	 *
	 * @param  {string} value
	 * @param  {string} [locale]
	 * @return {string}
	 */
	module.exports = function (value, locale) {
	  return noCase(value, locale, '.')
	}


/***/ }),

/***/ 503:
/***/ (function(module, exports, __webpack_require__) {

	var noCase = __webpack_require__(28)
	var upperCase = __webpack_require__(37)
	
	/**
	 * Header case a string.
	 *
	 * @param  {string} value
	 * @param  {string} [locale]
	 * @return {string}
	 */
	module.exports = function (value, locale) {
	  return noCase(value, locale, '-').replace(/^.|-./g, function (m) {
	    return upperCase(m, locale)
	  })
	}


/***/ }),

/***/ 521:
/***/ (function(module, exports, __webpack_require__) {

	var lowerCase = __webpack_require__(81)
	
	/**
	 * Check if a string is lower case.
	 *
	 * @param  {String}  string
	 * @param  {String}  [locale]
	 * @return {Boolean}
	 */
	module.exports = function (string, locale) {
	  return lowerCase(string, locale) === string
	}


/***/ }),

/***/ 522:
/***/ (function(module, exports, __webpack_require__) {

	var upperCase = __webpack_require__(37)
	
	/**
	 * Check if a string is upper case.
	 *
	 * @param  {String}  string
	 * @param  {String}  [locale]
	 * @return {Boolean}
	 */
	module.exports = function (string, locale) {
	  return upperCase(string, locale) === string
	}


/***/ }),

/***/ 587:
/***/ (function(module, exports, __webpack_require__) {

	var lowerCase = __webpack_require__(81)
	
	/**
	 * Lower case the first character of a string.
	 *
	 * @param  {String} str
	 * @return {String}
	 */
	module.exports = function (str, locale) {
	  if (str == null) {
	    return ''
	  }
	
	  str = String(str)
	
	  return lowerCase(str.charAt(0), locale) + str.substr(1)
	}


/***/ }),

/***/ 81:
/***/ (function(module, exports) {

	/**
	 * Special language-specific overrides.
	 *
	 * Source: ftp://ftp.unicode.org/Public/UCD/latest/ucd/SpecialCasing.txt
	 *
	 * @type {Object}
	 */
	var LANGUAGES = {
	  tr: {
	    regexp: /\u0130|\u0049|\u0049\u0307/g,
	    map: {
	      '\u0130': '\u0069',
	      '\u0049': '\u0131',
	      '\u0049\u0307': '\u0069'
	    }
	  },
	  az: {
	    regexp: /[\u0130]/g,
	    map: {
	      '\u0130': '\u0069',
	      '\u0049': '\u0131',
	      '\u0049\u0307': '\u0069'
	    }
	  },
	  lt: {
	    regexp: /[\u0049\u004A\u012E\u00CC\u00CD\u0128]/g,
	    map: {
	      '\u0049': '\u0069\u0307',
	      '\u004A': '\u006A\u0307',
	      '\u012E': '\u012F\u0307',
	      '\u00CC': '\u0069\u0307\u0300',
	      '\u00CD': '\u0069\u0307\u0301',
	      '\u0128': '\u0069\u0307\u0303'
	    }
	  }
	}
	
	/**
	 * Lowercase a string.
	 *
	 * @param  {String} str
	 * @return {String}
	 */
	module.exports = function (str, locale) {
	  var lang = LANGUAGES[locale]
	
	  str = str == null ? '' : String(str)
	
	  if (lang) {
	    str = str.replace(lang.regexp, function (m) { return lang.map[m] })
	  }
	
	  return str.toLowerCase()
	}


/***/ }),

/***/ 28:
/***/ (function(module, exports, __webpack_require__) {

	var lowerCase = __webpack_require__(81)
	
	var NON_WORD_REGEXP = __webpack_require__(591)
	var CAMEL_CASE_REGEXP = __webpack_require__(589)
	var CAMEL_CASE_UPPER_REGEXP = __webpack_require__(590)
	
	/**
	 * Sentence case a string.
	 *
	 * @param  {string} str
	 * @param  {string} locale
	 * @param  {string} replacement
	 * @return {string}
	 */
	module.exports = function (str, locale, replacement) {
	  if (str == null) {
	    return ''
	  }
	
	  replacement = typeof replacement !== 'string' ? ' ' : replacement
	
	  function replace (match, index, value) {
	    if (index === 0 || index === (value.length - match.length)) {
	      return ''
	    }
	
	    return replacement
	  }
	
	  str = String(str)
	    // Support camel case ("camelCase" -> "camel Case").
	    .replace(CAMEL_CASE_REGEXP, '$1 $2')
	    // Support odd camel case ("CAMELCase" -> "CAMEL Case").
	    .replace(CAMEL_CASE_UPPER_REGEXP, '$1 $2')
	    // Remove all non-word characters and replace with a single space.
	    .replace(NON_WORD_REGEXP, replace)
	
	  // Lower case the entire string.
	  return lowerCase(str, locale)
	}


/***/ }),

/***/ 589:
/***/ (function(module, exports) {

	module.exports = /([a-z\xB5\xDF-\xF6\xF8-\xFF\u0101\u0103\u0105\u0107\u0109\u010B\u010D\u010F\u0111\u0113\u0115\u0117\u0119\u011B\u011D\u011F\u0121\u0123\u0125\u0127\u0129\u012B\u012D\u012F\u0131\u0133\u0135\u0137\u0138\u013A\u013C\u013E\u0140\u0142\u0144\u0146\u0148\u0149\u014B\u014D\u014F\u0151\u0153\u0155\u0157\u0159\u015B\u015D\u015F\u0161\u0163\u0165\u0167\u0169\u016B\u016D\u016F\u0171\u0173\u0175\u0177\u017A\u017C\u017E-\u0180\u0183\u0185\u0188\u018C\u018D\u0192\u0195\u0199-\u019B\u019E\u01A1\u01A3\u01A5\u01A8\u01AA\u01AB\u01AD\u01B0\u01B4\u01B6\u01B9\u01BA\u01BD-\u01BF\u01C6\u01C9\u01CC\u01CE\u01D0\u01D2\u01D4\u01D6\u01D8\u01DA\u01DC\u01DD\u01DF\u01E1\u01E3\u01E5\u01E7\u01E9\u01EB\u01ED\u01EF\u01F0\u01F3\u01F5\u01F9\u01FB\u01FD\u01FF\u0201\u0203\u0205\u0207\u0209\u020B\u020D\u020F\u0211\u0213\u0215\u0217\u0219\u021B\u021D\u021F\u0221\u0223\u0225\u0227\u0229\u022B\u022D\u022F\u0231\u0233-\u0239\u023C\u023F\u0240\u0242\u0247\u0249\u024B\u024D\u024F-\u0293\u0295-\u02AF\u0371\u0373\u0377\u037B-\u037D\u0390\u03AC-\u03CE\u03D0\u03D1\u03D5-\u03D7\u03D9\u03DB\u03DD\u03DF\u03E1\u03E3\u03E5\u03E7\u03E9\u03EB\u03ED\u03EF-\u03F3\u03F5\u03F8\u03FB\u03FC\u0430-\u045F\u0461\u0463\u0465\u0467\u0469\u046B\u046D\u046F\u0471\u0473\u0475\u0477\u0479\u047B\u047D\u047F\u0481\u048B\u048D\u048F\u0491\u0493\u0495\u0497\u0499\u049B\u049D\u049F\u04A1\u04A3\u04A5\u04A7\u04A9\u04AB\u04AD\u04AF\u04B1\u04B3\u04B5\u04B7\u04B9\u04BB\u04BD\u04BF\u04C2\u04C4\u04C6\u04C8\u04CA\u04CC\u04CE\u04CF\u04D1\u04D3\u04D5\u04D7\u04D9\u04DB\u04DD\u04DF\u04E1\u04E3\u04E5\u04E7\u04E9\u04EB\u04ED\u04EF\u04F1\u04F3\u04F5\u04F7\u04F9\u04FB\u04FD\u04FF\u0501\u0503\u0505\u0507\u0509\u050B\u050D\u050F\u0511\u0513\u0515\u0517\u0519\u051B\u051D\u051F\u0521\u0523\u0525\u0527\u0529\u052B\u052D\u052F\u0561-\u0587\u13F8-\u13FD\u1D00-\u1D2B\u1D6B-\u1D77\u1D79-\u1D9A\u1E01\u1E03\u1E05\u1E07\u1E09\u1E0B\u1E0D\u1E0F\u1E11\u1E13\u1E15\u1E17\u1E19\u1E1B\u1E1D\u1E1F\u1E21\u1E23\u1E25\u1E27\u1E29\u1E2B\u1E2D\u1E2F\u1E31\u1E33\u1E35\u1E37\u1E39\u1E3B\u1E3D\u1E3F\u1E41\u1E43\u1E45\u1E47\u1E49\u1E4B\u1E4D\u1E4F\u1E51\u1E53\u1E55\u1E57\u1E59\u1E5B\u1E5D\u1E5F\u1E61\u1E63\u1E65\u1E67\u1E69\u1E6B\u1E6D\u1E6F\u1E71\u1E73\u1E75\u1E77\u1E79\u1E7B\u1E7D\u1E7F\u1E81\u1E83\u1E85\u1E87\u1E89\u1E8B\u1E8D\u1E8F\u1E91\u1E93\u1E95-\u1E9D\u1E9F\u1EA1\u1EA3\u1EA5\u1EA7\u1EA9\u1EAB\u1EAD\u1EAF\u1EB1\u1EB3\u1EB5\u1EB7\u1EB9\u1EBB\u1EBD\u1EBF\u1EC1\u1EC3\u1EC5\u1EC7\u1EC9\u1ECB\u1ECD\u1ECF\u1ED1\u1ED3\u1ED5\u1ED7\u1ED9\u1EDB\u1EDD\u1EDF\u1EE1\u1EE3\u1EE5\u1EE7\u1EE9\u1EEB\u1EED\u1EEF\u1EF1\u1EF3\u1EF5\u1EF7\u1EF9\u1EFB\u1EFD\u1EFF-\u1F07\u1F10-\u1F15\u1F20-\u1F27\u1F30-\u1F37\u1F40-\u1F45\u1F50-\u1F57\u1F60-\u1F67\u1F70-\u1F7D\u1F80-\u1F87\u1F90-\u1F97\u1FA0-\u1FA7\u1FB0-\u1FB4\u1FB6\u1FB7\u1FBE\u1FC2-\u1FC4\u1FC6\u1FC7\u1FD0-\u1FD3\u1FD6\u1FD7\u1FE0-\u1FE7\u1FF2-\u1FF4\u1FF6\u1FF7\u210A\u210E\u210F\u2113\u212F\u2134\u2139\u213C\u213D\u2146-\u2149\u214E\u2184\u2C30-\u2C5E\u2C61\u2C65\u2C66\u2C68\u2C6A\u2C6C\u2C71\u2C73\u2C74\u2C76-\u2C7B\u2C81\u2C83\u2C85\u2C87\u2C89\u2C8B\u2C8D\u2C8F\u2C91\u2C93\u2C95\u2C97\u2C99\u2C9B\u2C9D\u2C9F\u2CA1\u2CA3\u2CA5\u2CA7\u2CA9\u2CAB\u2CAD\u2CAF\u2CB1\u2CB3\u2CB5\u2CB7\u2CB9\u2CBB\u2CBD\u2CBF\u2CC1\u2CC3\u2CC5\u2CC7\u2CC9\u2CCB\u2CCD\u2CCF\u2CD1\u2CD3\u2CD5\u2CD7\u2CD9\u2CDB\u2CDD\u2CDF\u2CE1\u2CE3\u2CE4\u2CEC\u2CEE\u2CF3\u2D00-\u2D25\u2D27\u2D2D\uA641\uA643\uA645\uA647\uA649\uA64B\uA64D\uA64F\uA651\uA653\uA655\uA657\uA659\uA65B\uA65D\uA65F\uA661\uA663\uA665\uA667\uA669\uA66B\uA66D\uA681\uA683\uA685\uA687\uA689\uA68B\uA68D\uA68F\uA691\uA693\uA695\uA697\uA699\uA69B\uA723\uA725\uA727\uA729\uA72B\uA72D\uA72F-\uA731\uA733\uA735\uA737\uA739\uA73B\uA73D\uA73F\uA741\uA743\uA745\uA747\uA749\uA74B\uA74D\uA74F\uA751\uA753\uA755\uA757\uA759\uA75B\uA75D\uA75F\uA761\uA763\uA765\uA767\uA769\uA76B\uA76D\uA76F\uA771-\uA778\uA77A\uA77C\uA77F\uA781\uA783\uA785\uA787\uA78C\uA78E\uA791\uA793-\uA795\uA797\uA799\uA79B\uA79D\uA79F\uA7A1\uA7A3\uA7A5\uA7A7\uA7A9\uA7B5\uA7B7\uA7FA\uAB30-\uAB5A\uAB60-\uAB65\uAB70-\uABBF\uFB00-\uFB06\uFB13-\uFB17\uFF41-\uFF5A0-9\xB2\xB3\xB9\xBC-\xBE\u0660-\u0669\u06F0-\u06F9\u07C0-\u07C9\u0966-\u096F\u09E6-\u09EF\u09F4-\u09F9\u0A66-\u0A6F\u0AE6-\u0AEF\u0B66-\u0B6F\u0B72-\u0B77\u0BE6-\u0BF2\u0C66-\u0C6F\u0C78-\u0C7E\u0CE6-\u0CEF\u0D66-\u0D75\u0DE6-\u0DEF\u0E50-\u0E59\u0ED0-\u0ED9\u0F20-\u0F33\u1040-\u1049\u1090-\u1099\u1369-\u137C\u16EE-\u16F0\u17E0-\u17E9\u17F0-\u17F9\u1810-\u1819\u1946-\u194F\u19D0-\u19DA\u1A80-\u1A89\u1A90-\u1A99\u1B50-\u1B59\u1BB0-\u1BB9\u1C40-\u1C49\u1C50-\u1C59\u2070\u2074-\u2079\u2080-\u2089\u2150-\u2182\u2185-\u2189\u2460-\u249B\u24EA-\u24FF\u2776-\u2793\u2CFD\u3007\u3021-\u3029\u3038-\u303A\u3192-\u3195\u3220-\u3229\u3248-\u324F\u3251-\u325F\u3280-\u3289\u32B1-\u32BF\uA620-\uA629\uA6E6-\uA6EF\uA830-\uA835\uA8D0-\uA8D9\uA900-\uA909\uA9D0-\uA9D9\uA9F0-\uA9F9\uAA50-\uAA59\uABF0-\uABF9\uFF10-\uFF19])([A-Z\xC0-\xD6\xD8-\xDE\u0100\u0102\u0104\u0106\u0108\u010A\u010C\u010E\u0110\u0112\u0114\u0116\u0118\u011A\u011C\u011E\u0120\u0122\u0124\u0126\u0128\u012A\u012C\u012E\u0130\u0132\u0134\u0136\u0139\u013B\u013D\u013F\u0141\u0143\u0145\u0147\u014A\u014C\u014E\u0150\u0152\u0154\u0156\u0158\u015A\u015C\u015E\u0160\u0162\u0164\u0166\u0168\u016A\u016C\u016E\u0170\u0172\u0174\u0176\u0178\u0179\u017B\u017D\u0181\u0182\u0184\u0186\u0187\u0189-\u018B\u018E-\u0191\u0193\u0194\u0196-\u0198\u019C\u019D\u019F\u01A0\u01A2\u01A4\u01A6\u01A7\u01A9\u01AC\u01AE\u01AF\u01B1-\u01B3\u01B5\u01B7\u01B8\u01BC\u01C4\u01C7\u01CA\u01CD\u01CF\u01D1\u01D3\u01D5\u01D7\u01D9\u01DB\u01DE\u01E0\u01E2\u01E4\u01E6\u01E8\u01EA\u01EC\u01EE\u01F1\u01F4\u01F6-\u01F8\u01FA\u01FC\u01FE\u0200\u0202\u0204\u0206\u0208\u020A\u020C\u020E\u0210\u0212\u0214\u0216\u0218\u021A\u021C\u021E\u0220\u0222\u0224\u0226\u0228\u022A\u022C\u022E\u0230\u0232\u023A\u023B\u023D\u023E\u0241\u0243-\u0246\u0248\u024A\u024C\u024E\u0370\u0372\u0376\u037F\u0386\u0388-\u038A\u038C\u038E\u038F\u0391-\u03A1\u03A3-\u03AB\u03CF\u03D2-\u03D4\u03D8\u03DA\u03DC\u03DE\u03E0\u03E2\u03E4\u03E6\u03E8\u03EA\u03EC\u03EE\u03F4\u03F7\u03F9\u03FA\u03FD-\u042F\u0460\u0462\u0464\u0466\u0468\u046A\u046C\u046E\u0470\u0472\u0474\u0476\u0478\u047A\u047C\u047E\u0480\u048A\u048C\u048E\u0490\u0492\u0494\u0496\u0498\u049A\u049C\u049E\u04A0\u04A2\u04A4\u04A6\u04A8\u04AA\u04AC\u04AE\u04B0\u04B2\u04B4\u04B6\u04B8\u04BA\u04BC\u04BE\u04C0\u04C1\u04C3\u04C5\u04C7\u04C9\u04CB\u04CD\u04D0\u04D2\u04D4\u04D6\u04D8\u04DA\u04DC\u04DE\u04E0\u04E2\u04E4\u04E6\u04E8\u04EA\u04EC\u04EE\u04F0\u04F2\u04F4\u04F6\u04F8\u04FA\u04FC\u04FE\u0500\u0502\u0504\u0506\u0508\u050A\u050C\u050E\u0510\u0512\u0514\u0516\u0518\u051A\u051C\u051E\u0520\u0522\u0524\u0526\u0528\u052A\u052C\u052E\u0531-\u0556\u10A0-\u10C5\u10C7\u10CD\u13A0-\u13F5\u1E00\u1E02\u1E04\u1E06\u1E08\u1E0A\u1E0C\u1E0E\u1E10\u1E12\u1E14\u1E16\u1E18\u1E1A\u1E1C\u1E1E\u1E20\u1E22\u1E24\u1E26\u1E28\u1E2A\u1E2C\u1E2E\u1E30\u1E32\u1E34\u1E36\u1E38\u1E3A\u1E3C\u1E3E\u1E40\u1E42\u1E44\u1E46\u1E48\u1E4A\u1E4C\u1E4E\u1E50\u1E52\u1E54\u1E56\u1E58\u1E5A\u1E5C\u1E5E\u1E60\u1E62\u1E64\u1E66\u1E68\u1E6A\u1E6C\u1E6E\u1E70\u1E72\u1E74\u1E76\u1E78\u1E7A\u1E7C\u1E7E\u1E80\u1E82\u1E84\u1E86\u1E88\u1E8A\u1E8C\u1E8E\u1E90\u1E92\u1E94\u1E9E\u1EA0\u1EA2\u1EA4\u1EA6\u1EA8\u1EAA\u1EAC\u1EAE\u1EB0\u1EB2\u1EB4\u1EB6\u1EB8\u1EBA\u1EBC\u1EBE\u1EC0\u1EC2\u1EC4\u1EC6\u1EC8\u1ECA\u1ECC\u1ECE\u1ED0\u1ED2\u1ED4\u1ED6\u1ED8\u1EDA\u1EDC\u1EDE\u1EE0\u1EE2\u1EE4\u1EE6\u1EE8\u1EEA\u1EEC\u1EEE\u1EF0\u1EF2\u1EF4\u1EF6\u1EF8\u1EFA\u1EFC\u1EFE\u1F08-\u1F0F\u1F18-\u1F1D\u1F28-\u1F2F\u1F38-\u1F3F\u1F48-\u1F4D\u1F59\u1F5B\u1F5D\u1F5F\u1F68-\u1F6F\u1FB8-\u1FBB\u1FC8-\u1FCB\u1FD8-\u1FDB\u1FE8-\u1FEC\u1FF8-\u1FFB\u2102\u2107\u210B-\u210D\u2110-\u2112\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u2130-\u2133\u213E\u213F\u2145\u2183\u2C00-\u2C2E\u2C60\u2C62-\u2C64\u2C67\u2C69\u2C6B\u2C6D-\u2C70\u2C72\u2C75\u2C7E-\u2C80\u2C82\u2C84\u2C86\u2C88\u2C8A\u2C8C\u2C8E\u2C90\u2C92\u2C94\u2C96\u2C98\u2C9A\u2C9C\u2C9E\u2CA0\u2CA2\u2CA4\u2CA6\u2CA8\u2CAA\u2CAC\u2CAE\u2CB0\u2CB2\u2CB4\u2CB6\u2CB8\u2CBA\u2CBC\u2CBE\u2CC0\u2CC2\u2CC4\u2CC6\u2CC8\u2CCA\u2CCC\u2CCE\u2CD0\u2CD2\u2CD4\u2CD6\u2CD8\u2CDA\u2CDC\u2CDE\u2CE0\u2CE2\u2CEB\u2CED\u2CF2\uA640\uA642\uA644\uA646\uA648\uA64A\uA64C\uA64E\uA650\uA652\uA654\uA656\uA658\uA65A\uA65C\uA65E\uA660\uA662\uA664\uA666\uA668\uA66A\uA66C\uA680\uA682\uA684\uA686\uA688\uA68A\uA68C\uA68E\uA690\uA692\uA694\uA696\uA698\uA69A\uA722\uA724\uA726\uA728\uA72A\uA72C\uA72E\uA732\uA734\uA736\uA738\uA73A\uA73C\uA73E\uA740\uA742\uA744\uA746\uA748\uA74A\uA74C\uA74E\uA750\uA752\uA754\uA756\uA758\uA75A\uA75C\uA75E\uA760\uA762\uA764\uA766\uA768\uA76A\uA76C\uA76E\uA779\uA77B\uA77D\uA77E\uA780\uA782\uA784\uA786\uA78B\uA78D\uA790\uA792\uA796\uA798\uA79A\uA79C\uA79E\uA7A0\uA7A2\uA7A4\uA7A6\uA7A8\uA7AA-\uA7AD\uA7B0-\uA7B4\uA7B6\uFF21-\uFF3A])/g


/***/ }),

/***/ 590:
/***/ (function(module, exports) {

	module.exports = /([A-Z\xC0-\xD6\xD8-\xDE\u0100\u0102\u0104\u0106\u0108\u010A\u010C\u010E\u0110\u0112\u0114\u0116\u0118\u011A\u011C\u011E\u0120\u0122\u0124\u0126\u0128\u012A\u012C\u012E\u0130\u0132\u0134\u0136\u0139\u013B\u013D\u013F\u0141\u0143\u0145\u0147\u014A\u014C\u014E\u0150\u0152\u0154\u0156\u0158\u015A\u015C\u015E\u0160\u0162\u0164\u0166\u0168\u016A\u016C\u016E\u0170\u0172\u0174\u0176\u0178\u0179\u017B\u017D\u0181\u0182\u0184\u0186\u0187\u0189-\u018B\u018E-\u0191\u0193\u0194\u0196-\u0198\u019C\u019D\u019F\u01A0\u01A2\u01A4\u01A6\u01A7\u01A9\u01AC\u01AE\u01AF\u01B1-\u01B3\u01B5\u01B7\u01B8\u01BC\u01C4\u01C7\u01CA\u01CD\u01CF\u01D1\u01D3\u01D5\u01D7\u01D9\u01DB\u01DE\u01E0\u01E2\u01E4\u01E6\u01E8\u01EA\u01EC\u01EE\u01F1\u01F4\u01F6-\u01F8\u01FA\u01FC\u01FE\u0200\u0202\u0204\u0206\u0208\u020A\u020C\u020E\u0210\u0212\u0214\u0216\u0218\u021A\u021C\u021E\u0220\u0222\u0224\u0226\u0228\u022A\u022C\u022E\u0230\u0232\u023A\u023B\u023D\u023E\u0241\u0243-\u0246\u0248\u024A\u024C\u024E\u0370\u0372\u0376\u037F\u0386\u0388-\u038A\u038C\u038E\u038F\u0391-\u03A1\u03A3-\u03AB\u03CF\u03D2-\u03D4\u03D8\u03DA\u03DC\u03DE\u03E0\u03E2\u03E4\u03E6\u03E8\u03EA\u03EC\u03EE\u03F4\u03F7\u03F9\u03FA\u03FD-\u042F\u0460\u0462\u0464\u0466\u0468\u046A\u046C\u046E\u0470\u0472\u0474\u0476\u0478\u047A\u047C\u047E\u0480\u048A\u048C\u048E\u0490\u0492\u0494\u0496\u0498\u049A\u049C\u049E\u04A0\u04A2\u04A4\u04A6\u04A8\u04AA\u04AC\u04AE\u04B0\u04B2\u04B4\u04B6\u04B8\u04BA\u04BC\u04BE\u04C0\u04C1\u04C3\u04C5\u04C7\u04C9\u04CB\u04CD\u04D0\u04D2\u04D4\u04D6\u04D8\u04DA\u04DC\u04DE\u04E0\u04E2\u04E4\u04E6\u04E8\u04EA\u04EC\u04EE\u04F0\u04F2\u04F4\u04F6\u04F8\u04FA\u04FC\u04FE\u0500\u0502\u0504\u0506\u0508\u050A\u050C\u050E\u0510\u0512\u0514\u0516\u0518\u051A\u051C\u051E\u0520\u0522\u0524\u0526\u0528\u052A\u052C\u052E\u0531-\u0556\u10A0-\u10C5\u10C7\u10CD\u13A0-\u13F5\u1E00\u1E02\u1E04\u1E06\u1E08\u1E0A\u1E0C\u1E0E\u1E10\u1E12\u1E14\u1E16\u1E18\u1E1A\u1E1C\u1E1E\u1E20\u1E22\u1E24\u1E26\u1E28\u1E2A\u1E2C\u1E2E\u1E30\u1E32\u1E34\u1E36\u1E38\u1E3A\u1E3C\u1E3E\u1E40\u1E42\u1E44\u1E46\u1E48\u1E4A\u1E4C\u1E4E\u1E50\u1E52\u1E54\u1E56\u1E58\u1E5A\u1E5C\u1E5E\u1E60\u1E62\u1E64\u1E66\u1E68\u1E6A\u1E6C\u1E6E\u1E70\u1E72\u1E74\u1E76\u1E78\u1E7A\u1E7C\u1E7E\u1E80\u1E82\u1E84\u1E86\u1E88\u1E8A\u1E8C\u1E8E\u1E90\u1E92\u1E94\u1E9E\u1EA0\u1EA2\u1EA4\u1EA6\u1EA8\u1EAA\u1EAC\u1EAE\u1EB0\u1EB2\u1EB4\u1EB6\u1EB8\u1EBA\u1EBC\u1EBE\u1EC0\u1EC2\u1EC4\u1EC6\u1EC8\u1ECA\u1ECC\u1ECE\u1ED0\u1ED2\u1ED4\u1ED6\u1ED8\u1EDA\u1EDC\u1EDE\u1EE0\u1EE2\u1EE4\u1EE6\u1EE8\u1EEA\u1EEC\u1EEE\u1EF0\u1EF2\u1EF4\u1EF6\u1EF8\u1EFA\u1EFC\u1EFE\u1F08-\u1F0F\u1F18-\u1F1D\u1F28-\u1F2F\u1F38-\u1F3F\u1F48-\u1F4D\u1F59\u1F5B\u1F5D\u1F5F\u1F68-\u1F6F\u1FB8-\u1FBB\u1FC8-\u1FCB\u1FD8-\u1FDB\u1FE8-\u1FEC\u1FF8-\u1FFB\u2102\u2107\u210B-\u210D\u2110-\u2112\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u2130-\u2133\u213E\u213F\u2145\u2183\u2C00-\u2C2E\u2C60\u2C62-\u2C64\u2C67\u2C69\u2C6B\u2C6D-\u2C70\u2C72\u2C75\u2C7E-\u2C80\u2C82\u2C84\u2C86\u2C88\u2C8A\u2C8C\u2C8E\u2C90\u2C92\u2C94\u2C96\u2C98\u2C9A\u2C9C\u2C9E\u2CA0\u2CA2\u2CA4\u2CA6\u2CA8\u2CAA\u2CAC\u2CAE\u2CB0\u2CB2\u2CB4\u2CB6\u2CB8\u2CBA\u2CBC\u2CBE\u2CC0\u2CC2\u2CC4\u2CC6\u2CC8\u2CCA\u2CCC\u2CCE\u2CD0\u2CD2\u2CD4\u2CD6\u2CD8\u2CDA\u2CDC\u2CDE\u2CE0\u2CE2\u2CEB\u2CED\u2CF2\uA640\uA642\uA644\uA646\uA648\uA64A\uA64C\uA64E\uA650\uA652\uA654\uA656\uA658\uA65A\uA65C\uA65E\uA660\uA662\uA664\uA666\uA668\uA66A\uA66C\uA680\uA682\uA684\uA686\uA688\uA68A\uA68C\uA68E\uA690\uA692\uA694\uA696\uA698\uA69A\uA722\uA724\uA726\uA728\uA72A\uA72C\uA72E\uA732\uA734\uA736\uA738\uA73A\uA73C\uA73E\uA740\uA742\uA744\uA746\uA748\uA74A\uA74C\uA74E\uA750\uA752\uA754\uA756\uA758\uA75A\uA75C\uA75E\uA760\uA762\uA764\uA766\uA768\uA76A\uA76C\uA76E\uA779\uA77B\uA77D\uA77E\uA780\uA782\uA784\uA786\uA78B\uA78D\uA790\uA792\uA796\uA798\uA79A\uA79C\uA79E\uA7A0\uA7A2\uA7A4\uA7A6\uA7A8\uA7AA-\uA7AD\uA7B0-\uA7B4\uA7B6\uFF21-\uFF3A])([A-Z\xC0-\xD6\xD8-\xDE\u0100\u0102\u0104\u0106\u0108\u010A\u010C\u010E\u0110\u0112\u0114\u0116\u0118\u011A\u011C\u011E\u0120\u0122\u0124\u0126\u0128\u012A\u012C\u012E\u0130\u0132\u0134\u0136\u0139\u013B\u013D\u013F\u0141\u0143\u0145\u0147\u014A\u014C\u014E\u0150\u0152\u0154\u0156\u0158\u015A\u015C\u015E\u0160\u0162\u0164\u0166\u0168\u016A\u016C\u016E\u0170\u0172\u0174\u0176\u0178\u0179\u017B\u017D\u0181\u0182\u0184\u0186\u0187\u0189-\u018B\u018E-\u0191\u0193\u0194\u0196-\u0198\u019C\u019D\u019F\u01A0\u01A2\u01A4\u01A6\u01A7\u01A9\u01AC\u01AE\u01AF\u01B1-\u01B3\u01B5\u01B7\u01B8\u01BC\u01C4\u01C7\u01CA\u01CD\u01CF\u01D1\u01D3\u01D5\u01D7\u01D9\u01DB\u01DE\u01E0\u01E2\u01E4\u01E6\u01E8\u01EA\u01EC\u01EE\u01F1\u01F4\u01F6-\u01F8\u01FA\u01FC\u01FE\u0200\u0202\u0204\u0206\u0208\u020A\u020C\u020E\u0210\u0212\u0214\u0216\u0218\u021A\u021C\u021E\u0220\u0222\u0224\u0226\u0228\u022A\u022C\u022E\u0230\u0232\u023A\u023B\u023D\u023E\u0241\u0243-\u0246\u0248\u024A\u024C\u024E\u0370\u0372\u0376\u037F\u0386\u0388-\u038A\u038C\u038E\u038F\u0391-\u03A1\u03A3-\u03AB\u03CF\u03D2-\u03D4\u03D8\u03DA\u03DC\u03DE\u03E0\u03E2\u03E4\u03E6\u03E8\u03EA\u03EC\u03EE\u03F4\u03F7\u03F9\u03FA\u03FD-\u042F\u0460\u0462\u0464\u0466\u0468\u046A\u046C\u046E\u0470\u0472\u0474\u0476\u0478\u047A\u047C\u047E\u0480\u048A\u048C\u048E\u0490\u0492\u0494\u0496\u0498\u049A\u049C\u049E\u04A0\u04A2\u04A4\u04A6\u04A8\u04AA\u04AC\u04AE\u04B0\u04B2\u04B4\u04B6\u04B8\u04BA\u04BC\u04BE\u04C0\u04C1\u04C3\u04C5\u04C7\u04C9\u04CB\u04CD\u04D0\u04D2\u04D4\u04D6\u04D8\u04DA\u04DC\u04DE\u04E0\u04E2\u04E4\u04E6\u04E8\u04EA\u04EC\u04EE\u04F0\u04F2\u04F4\u04F6\u04F8\u04FA\u04FC\u04FE\u0500\u0502\u0504\u0506\u0508\u050A\u050C\u050E\u0510\u0512\u0514\u0516\u0518\u051A\u051C\u051E\u0520\u0522\u0524\u0526\u0528\u052A\u052C\u052E\u0531-\u0556\u10A0-\u10C5\u10C7\u10CD\u13A0-\u13F5\u1E00\u1E02\u1E04\u1E06\u1E08\u1E0A\u1E0C\u1E0E\u1E10\u1E12\u1E14\u1E16\u1E18\u1E1A\u1E1C\u1E1E\u1E20\u1E22\u1E24\u1E26\u1E28\u1E2A\u1E2C\u1E2E\u1E30\u1E32\u1E34\u1E36\u1E38\u1E3A\u1E3C\u1E3E\u1E40\u1E42\u1E44\u1E46\u1E48\u1E4A\u1E4C\u1E4E\u1E50\u1E52\u1E54\u1E56\u1E58\u1E5A\u1E5C\u1E5E\u1E60\u1E62\u1E64\u1E66\u1E68\u1E6A\u1E6C\u1E6E\u1E70\u1E72\u1E74\u1E76\u1E78\u1E7A\u1E7C\u1E7E\u1E80\u1E82\u1E84\u1E86\u1E88\u1E8A\u1E8C\u1E8E\u1E90\u1E92\u1E94\u1E9E\u1EA0\u1EA2\u1EA4\u1EA6\u1EA8\u1EAA\u1EAC\u1EAE\u1EB0\u1EB2\u1EB4\u1EB6\u1EB8\u1EBA\u1EBC\u1EBE\u1EC0\u1EC2\u1EC4\u1EC6\u1EC8\u1ECA\u1ECC\u1ECE\u1ED0\u1ED2\u1ED4\u1ED6\u1ED8\u1EDA\u1EDC\u1EDE\u1EE0\u1EE2\u1EE4\u1EE6\u1EE8\u1EEA\u1EEC\u1EEE\u1EF0\u1EF2\u1EF4\u1EF6\u1EF8\u1EFA\u1EFC\u1EFE\u1F08-\u1F0F\u1F18-\u1F1D\u1F28-\u1F2F\u1F38-\u1F3F\u1F48-\u1F4D\u1F59\u1F5B\u1F5D\u1F5F\u1F68-\u1F6F\u1FB8-\u1FBB\u1FC8-\u1FCB\u1FD8-\u1FDB\u1FE8-\u1FEC\u1FF8-\u1FFB\u2102\u2107\u210B-\u210D\u2110-\u2112\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u2130-\u2133\u213E\u213F\u2145\u2183\u2C00-\u2C2E\u2C60\u2C62-\u2C64\u2C67\u2C69\u2C6B\u2C6D-\u2C70\u2C72\u2C75\u2C7E-\u2C80\u2C82\u2C84\u2C86\u2C88\u2C8A\u2C8C\u2C8E\u2C90\u2C92\u2C94\u2C96\u2C98\u2C9A\u2C9C\u2C9E\u2CA0\u2CA2\u2CA4\u2CA6\u2CA8\u2CAA\u2CAC\u2CAE\u2CB0\u2CB2\u2CB4\u2CB6\u2CB8\u2CBA\u2CBC\u2CBE\u2CC0\u2CC2\u2CC4\u2CC6\u2CC8\u2CCA\u2CCC\u2CCE\u2CD0\u2CD2\u2CD4\u2CD6\u2CD8\u2CDA\u2CDC\u2CDE\u2CE0\u2CE2\u2CEB\u2CED\u2CF2\uA640\uA642\uA644\uA646\uA648\uA64A\uA64C\uA64E\uA650\uA652\uA654\uA656\uA658\uA65A\uA65C\uA65E\uA660\uA662\uA664\uA666\uA668\uA66A\uA66C\uA680\uA682\uA684\uA686\uA688\uA68A\uA68C\uA68E\uA690\uA692\uA694\uA696\uA698\uA69A\uA722\uA724\uA726\uA728\uA72A\uA72C\uA72E\uA732\uA734\uA736\uA738\uA73A\uA73C\uA73E\uA740\uA742\uA744\uA746\uA748\uA74A\uA74C\uA74E\uA750\uA752\uA754\uA756\uA758\uA75A\uA75C\uA75E\uA760\uA762\uA764\uA766\uA768\uA76A\uA76C\uA76E\uA779\uA77B\uA77D\uA77E\uA780\uA782\uA784\uA786\uA78B\uA78D\uA790\uA792\uA796\uA798\uA79A\uA79C\uA79E\uA7A0\uA7A2\uA7A4\uA7A6\uA7A8\uA7AA-\uA7AD\uA7B0-\uA7B4\uA7B6\uFF21-\uFF3A][a-z\xB5\xDF-\xF6\xF8-\xFF\u0101\u0103\u0105\u0107\u0109\u010B\u010D\u010F\u0111\u0113\u0115\u0117\u0119\u011B\u011D\u011F\u0121\u0123\u0125\u0127\u0129\u012B\u012D\u012F\u0131\u0133\u0135\u0137\u0138\u013A\u013C\u013E\u0140\u0142\u0144\u0146\u0148\u0149\u014B\u014D\u014F\u0151\u0153\u0155\u0157\u0159\u015B\u015D\u015F\u0161\u0163\u0165\u0167\u0169\u016B\u016D\u016F\u0171\u0173\u0175\u0177\u017A\u017C\u017E-\u0180\u0183\u0185\u0188\u018C\u018D\u0192\u0195\u0199-\u019B\u019E\u01A1\u01A3\u01A5\u01A8\u01AA\u01AB\u01AD\u01B0\u01B4\u01B6\u01B9\u01BA\u01BD-\u01BF\u01C6\u01C9\u01CC\u01CE\u01D0\u01D2\u01D4\u01D6\u01D8\u01DA\u01DC\u01DD\u01DF\u01E1\u01E3\u01E5\u01E7\u01E9\u01EB\u01ED\u01EF\u01F0\u01F3\u01F5\u01F9\u01FB\u01FD\u01FF\u0201\u0203\u0205\u0207\u0209\u020B\u020D\u020F\u0211\u0213\u0215\u0217\u0219\u021B\u021D\u021F\u0221\u0223\u0225\u0227\u0229\u022B\u022D\u022F\u0231\u0233-\u0239\u023C\u023F\u0240\u0242\u0247\u0249\u024B\u024D\u024F-\u0293\u0295-\u02AF\u0371\u0373\u0377\u037B-\u037D\u0390\u03AC-\u03CE\u03D0\u03D1\u03D5-\u03D7\u03D9\u03DB\u03DD\u03DF\u03E1\u03E3\u03E5\u03E7\u03E9\u03EB\u03ED\u03EF-\u03F3\u03F5\u03F8\u03FB\u03FC\u0430-\u045F\u0461\u0463\u0465\u0467\u0469\u046B\u046D\u046F\u0471\u0473\u0475\u0477\u0479\u047B\u047D\u047F\u0481\u048B\u048D\u048F\u0491\u0493\u0495\u0497\u0499\u049B\u049D\u049F\u04A1\u04A3\u04A5\u04A7\u04A9\u04AB\u04AD\u04AF\u04B1\u04B3\u04B5\u04B7\u04B9\u04BB\u04BD\u04BF\u04C2\u04C4\u04C6\u04C8\u04CA\u04CC\u04CE\u04CF\u04D1\u04D3\u04D5\u04D7\u04D9\u04DB\u04DD\u04DF\u04E1\u04E3\u04E5\u04E7\u04E9\u04EB\u04ED\u04EF\u04F1\u04F3\u04F5\u04F7\u04F9\u04FB\u04FD\u04FF\u0501\u0503\u0505\u0507\u0509\u050B\u050D\u050F\u0511\u0513\u0515\u0517\u0519\u051B\u051D\u051F\u0521\u0523\u0525\u0527\u0529\u052B\u052D\u052F\u0561-\u0587\u13F8-\u13FD\u1D00-\u1D2B\u1D6B-\u1D77\u1D79-\u1D9A\u1E01\u1E03\u1E05\u1E07\u1E09\u1E0B\u1E0D\u1E0F\u1E11\u1E13\u1E15\u1E17\u1E19\u1E1B\u1E1D\u1E1F\u1E21\u1E23\u1E25\u1E27\u1E29\u1E2B\u1E2D\u1E2F\u1E31\u1E33\u1E35\u1E37\u1E39\u1E3B\u1E3D\u1E3F\u1E41\u1E43\u1E45\u1E47\u1E49\u1E4B\u1E4D\u1E4F\u1E51\u1E53\u1E55\u1E57\u1E59\u1E5B\u1E5D\u1E5F\u1E61\u1E63\u1E65\u1E67\u1E69\u1E6B\u1E6D\u1E6F\u1E71\u1E73\u1E75\u1E77\u1E79\u1E7B\u1E7D\u1E7F\u1E81\u1E83\u1E85\u1E87\u1E89\u1E8B\u1E8D\u1E8F\u1E91\u1E93\u1E95-\u1E9D\u1E9F\u1EA1\u1EA3\u1EA5\u1EA7\u1EA9\u1EAB\u1EAD\u1EAF\u1EB1\u1EB3\u1EB5\u1EB7\u1EB9\u1EBB\u1EBD\u1EBF\u1EC1\u1EC3\u1EC5\u1EC7\u1EC9\u1ECB\u1ECD\u1ECF\u1ED1\u1ED3\u1ED5\u1ED7\u1ED9\u1EDB\u1EDD\u1EDF\u1EE1\u1EE3\u1EE5\u1EE7\u1EE9\u1EEB\u1EED\u1EEF\u1EF1\u1EF3\u1EF5\u1EF7\u1EF9\u1EFB\u1EFD\u1EFF-\u1F07\u1F10-\u1F15\u1F20-\u1F27\u1F30-\u1F37\u1F40-\u1F45\u1F50-\u1F57\u1F60-\u1F67\u1F70-\u1F7D\u1F80-\u1F87\u1F90-\u1F97\u1FA0-\u1FA7\u1FB0-\u1FB4\u1FB6\u1FB7\u1FBE\u1FC2-\u1FC4\u1FC6\u1FC7\u1FD0-\u1FD3\u1FD6\u1FD7\u1FE0-\u1FE7\u1FF2-\u1FF4\u1FF6\u1FF7\u210A\u210E\u210F\u2113\u212F\u2134\u2139\u213C\u213D\u2146-\u2149\u214E\u2184\u2C30-\u2C5E\u2C61\u2C65\u2C66\u2C68\u2C6A\u2C6C\u2C71\u2C73\u2C74\u2C76-\u2C7B\u2C81\u2C83\u2C85\u2C87\u2C89\u2C8B\u2C8D\u2C8F\u2C91\u2C93\u2C95\u2C97\u2C99\u2C9B\u2C9D\u2C9F\u2CA1\u2CA3\u2CA5\u2CA7\u2CA9\u2CAB\u2CAD\u2CAF\u2CB1\u2CB3\u2CB5\u2CB7\u2CB9\u2CBB\u2CBD\u2CBF\u2CC1\u2CC3\u2CC5\u2CC7\u2CC9\u2CCB\u2CCD\u2CCF\u2CD1\u2CD3\u2CD5\u2CD7\u2CD9\u2CDB\u2CDD\u2CDF\u2CE1\u2CE3\u2CE4\u2CEC\u2CEE\u2CF3\u2D00-\u2D25\u2D27\u2D2D\uA641\uA643\uA645\uA647\uA649\uA64B\uA64D\uA64F\uA651\uA653\uA655\uA657\uA659\uA65B\uA65D\uA65F\uA661\uA663\uA665\uA667\uA669\uA66B\uA66D\uA681\uA683\uA685\uA687\uA689\uA68B\uA68D\uA68F\uA691\uA693\uA695\uA697\uA699\uA69B\uA723\uA725\uA727\uA729\uA72B\uA72D\uA72F-\uA731\uA733\uA735\uA737\uA739\uA73B\uA73D\uA73F\uA741\uA743\uA745\uA747\uA749\uA74B\uA74D\uA74F\uA751\uA753\uA755\uA757\uA759\uA75B\uA75D\uA75F\uA761\uA763\uA765\uA767\uA769\uA76B\uA76D\uA76F\uA771-\uA778\uA77A\uA77C\uA77F\uA781\uA783\uA785\uA787\uA78C\uA78E\uA791\uA793-\uA795\uA797\uA799\uA79B\uA79D\uA79F\uA7A1\uA7A3\uA7A5\uA7A7\uA7A9\uA7B5\uA7B7\uA7FA\uAB30-\uAB5A\uAB60-\uAB65\uAB70-\uABBF\uFB00-\uFB06\uFB13-\uFB17\uFF41-\uFF5A])/g


/***/ }),

/***/ 591:
/***/ (function(module, exports) {

	module.exports = /[^A-Za-z\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0-\u08B4\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC0-9\xB2\xB3\xB9\xBC-\xBE\u0660-\u0669\u06F0-\u06F9\u07C0-\u07C9\u0966-\u096F\u09E6-\u09EF\u09F4-\u09F9\u0A66-\u0A6F\u0AE6-\u0AEF\u0B66-\u0B6F\u0B72-\u0B77\u0BE6-\u0BF2\u0C66-\u0C6F\u0C78-\u0C7E\u0CE6-\u0CEF\u0D66-\u0D75\u0DE6-\u0DEF\u0E50-\u0E59\u0ED0-\u0ED9\u0F20-\u0F33\u1040-\u1049\u1090-\u1099\u1369-\u137C\u16EE-\u16F0\u17E0-\u17E9\u17F0-\u17F9\u1810-\u1819\u1946-\u194F\u19D0-\u19DA\u1A80-\u1A89\u1A90-\u1A99\u1B50-\u1B59\u1BB0-\u1BB9\u1C40-\u1C49\u1C50-\u1C59\u2070\u2074-\u2079\u2080-\u2089\u2150-\u2182\u2185-\u2189\u2460-\u249B\u24EA-\u24FF\u2776-\u2793\u2CFD\u3007\u3021-\u3029\u3038-\u303A\u3192-\u3195\u3220-\u3229\u3248-\u324F\u3251-\u325F\u3280-\u3289\u32B1-\u32BF\uA620-\uA629\uA6E6-\uA6EF\uA830-\uA835\uA8D0-\uA8D9\uA900-\uA909\uA9D0-\uA9D9\uA9F0-\uA9F9\uAA50-\uAA59\uABF0-\uABF9\uFF10-\uFF19]+/g


/***/ }),

/***/ 608:
/***/ (function(module, exports, __webpack_require__) {

	var noCase = __webpack_require__(28)
	
	/**
	 * Param case a string.
	 *
	 * @param  {string} value
	 * @param  {string} [locale]
	 * @return {string}
	 */
	module.exports = function (value, locale) {
	  return noCase(value, locale, '-')
	}


/***/ }),

/***/ 609:
/***/ (function(module, exports, __webpack_require__) {

	var camelCase = __webpack_require__(202)
	var upperCaseFirst = __webpack_require__(196)
	
	/**
	 * Pascal case a string.
	 *
	 * @param  {string}  value
	 * @param  {string}  [locale]
	 * @param  {boolean} [mergeNumbers]
	 * @return {string}
	 */
	module.exports = function (value, locale, mergeNumbers) {
	  return upperCaseFirst(camelCase(value, locale, mergeNumbers), locale)
	}


/***/ }),

/***/ 610:
/***/ (function(module, exports, __webpack_require__) {

	var noCase = __webpack_require__(28)
	
	/**
	 * Path case a string.
	 *
	 * @param  {string} value
	 * @param  {string} [locale]
	 * @return {string}
	 */
	module.exports = function (value, locale) {
	  return noCase(value, locale, '/')
	}


/***/ }),

/***/ 90:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	function componentWillMount() {
	  // Call this.constructor.gDSFP to support sub-classes.
	  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
	  if (state !== null && state !== undefined) {
	    this.setState(state);
	  }
	}
	
	function componentWillReceiveProps(nextProps) {
	  // Call this.constructor.gDSFP to support sub-classes.
	  // Use the setState() updater to ensure state isn't stale in certain edge cases.
	  function updater(prevState) {
	    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
	    return state !== null && state !== undefined ? state : null;
	  }
	  // Binding "this" is important for shallow renderer support.
	  this.setState(updater.bind(this));
	}
	
	function componentWillUpdate(nextProps, nextState) {
	  try {
	    var prevProps = this.props;
	    var prevState = this.state;
	    this.props = nextProps;
	    this.state = nextState;
	    this.__reactInternalSnapshotFlag = true;
	    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
	      prevProps,
	      prevState
	    );
	  } finally {
	    this.props = prevProps;
	    this.state = prevState;
	  }
	}
	
	// React may warn about cWM/cWRP/cWU methods being deprecated.
	// Add a flag to suppress these warnings for this special case.
	componentWillMount.__suppressDeprecationWarning = true;
	componentWillReceiveProps.__suppressDeprecationWarning = true;
	componentWillUpdate.__suppressDeprecationWarning = true;
	
	function polyfill(Component) {
	  var prototype = Component.prototype;
	
	  if (!prototype || !prototype.isReactComponent) {
	    throw new Error('Can only polyfill class components');
	  }
	
	  if (
	    typeof Component.getDerivedStateFromProps !== 'function' &&
	    typeof prototype.getSnapshotBeforeUpdate !== 'function'
	  ) {
	    return Component;
	  }
	
	  // If new component APIs are defined, "unsafe" lifecycles won't be called.
	  // Error if any of these lifecycles are present,
	  // Because they would work differently between older and newer (16.3+) versions of React.
	  var foundWillMountName = null;
	  var foundWillReceivePropsName = null;
	  var foundWillUpdateName = null;
	  if (typeof prototype.componentWillMount === 'function') {
	    foundWillMountName = 'componentWillMount';
	  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
	    foundWillMountName = 'UNSAFE_componentWillMount';
	  }
	  if (typeof prototype.componentWillReceiveProps === 'function') {
	    foundWillReceivePropsName = 'componentWillReceiveProps';
	  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
	    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
	  }
	  if (typeof prototype.componentWillUpdate === 'function') {
	    foundWillUpdateName = 'componentWillUpdate';
	  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
	    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
	  }
	  if (
	    foundWillMountName !== null ||
	    foundWillReceivePropsName !== null ||
	    foundWillUpdateName !== null
	  ) {
	    var componentName = Component.displayName || Component.name;
	    var newApiName =
	      typeof Component.getDerivedStateFromProps === 'function'
	        ? 'getDerivedStateFromProps()'
	        : 'getSnapshotBeforeUpdate()';
	
	    throw Error(
	      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
	        componentName +
	        ' uses ' +
	        newApiName +
	        ' but also contains the following legacy lifecycles:' +
	        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
	        (foundWillReceivePropsName !== null
	          ? '\n  ' + foundWillReceivePropsName
	          : '') +
	        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
	        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
	        'https://fb.me/react-async-component-lifecycle-hooks'
	    );
	  }
	
	  // React <= 16.2 does not support static getDerivedStateFromProps.
	  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
	  // Newer versions of React will ignore these lifecycles if gDSFP exists.
	  if (typeof Component.getDerivedStateFromProps === 'function') {
	    prototype.componentWillMount = componentWillMount;
	    prototype.componentWillReceiveProps = componentWillReceiveProps;
	  }
	
	  // React <= 16.2 does not support getSnapshotBeforeUpdate.
	  // As a workaround, use cWU to invoke the new lifecycle.
	  // Newer versions of React will ignore that lifecycle if gSBU exists.
	  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
	    if (typeof prototype.componentDidUpdate !== 'function') {
	      throw new Error(
	        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
	      );
	    }
	
	    prototype.componentWillUpdate = componentWillUpdate;
	
	    var componentDidUpdate = prototype.componentDidUpdate;
	
	    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
	      prevProps,
	      prevState,
	      maybeSnapshot
	    ) {
	      // 16.3+ will not execute our will-update method;
	      // It will pass a snapshot value to did-update though.
	      // Older versions will require our polyfilled will-update value.
	      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
	      // Because for <= 15.x versions this might be a "prevContext" object.
	      // We also can't just check "__reactInternalSnapshot",
	      // Because get-snapshot might return a falsy value.
	      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
	      var snapshot = this.__reactInternalSnapshotFlag
	        ? this.__reactInternalSnapshot
	        : maybeSnapshot;
	
	      componentDidUpdate.call(this, prevProps, prevState, snapshot);
	    };
	  }
	
	  return Component;
	}
	
	exports.polyfill = polyfill;


/***/ }),

/***/ 193:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _propTypes = __webpack_require__(3);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _addClass = __webpack_require__(229);
	
	var _addClass2 = _interopRequireDefault(_addClass);
	
	var _removeClass = __webpack_require__(230);
	
	var _removeClass2 = _interopRequireDefault(_removeClass);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Transition = __webpack_require__(106);
	
	var _Transition2 = _interopRequireDefault(_Transition);
	
	var _PropTypes = __webpack_require__(108);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var addClass = function addClass(node, classes) {
	  return node && classes && classes.split(' ').forEach(function (c) {
	    return (0, _addClass2.default)(node, c);
	  });
	};
	var removeClass = function removeClass(node, classes) {
	  return node && classes && classes.split(' ').forEach(function (c) {
	    return (0, _removeClass2.default)(node, c);
	  });
	};
	
	var propTypes = _extends({}, _Transition2.default.propTypes, {
	
	  /**
	   * The animation classNames applied to the component as it enters, exits or has finished the transition.
	   * A single name can be provided and it will be suffixed for each stage: e.g.
	   *
	   * `classNames="fade"` applies `fade-enter`, `fade-enter-active`, `fade-enter-done`,
	   * `fade-exit`, `fade-exit-active`, `fade-exit-done`, `fade-appear`, and `fade-appear-active`.
	   * Each individual classNames can also be specified independently like:
	   *
	   * ```js
	   * classNames={{
	   *  appear: 'my-appear',
	   *  appearActive: 'my-active-appear',
	   *  enter: 'my-enter',
	   *  enterActive: 'my-active-enter',
	   *  enterDone: 'my-done-enter',
	   *  exit: 'my-exit',
	   *  exitActive: 'my-active-exit',
	   *  exitDone: 'my-done-exit',
	   * }}
	   * ```
	   *
	   * If you want to set these classes using CSS Modules:
	   *
	   * ```js
	   * import styles from './styles.css';
	   * ```
	   *
	   * you might want to use camelCase in your CSS file, that way could simply spread
	   * them instead of listing them one by one:
	   *
	   * ```js
	   * classNames={{ ...styles }}
	   * ```
	   *
	   * @type {string | {
	   *  appear?: string,
	   *  appearActive?: string,
	   *  enter?: string,
	   *  enterActive?: string,
	   *  enterDone?: string,
	   *  exit?: string,
	   *  exitActive?: string,
	   *  exitDone?: string,
	   * }}
	   */
	  classNames: _PropTypes.classNamesShape,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
	   * applied.
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEnter: PropTypes.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'enter-active' or
	   * 'appear-active' class is applied.
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEntering: PropTypes.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'enter' or
	   * 'appear' classes are **removed** and the `done` class is added to the DOM node.
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEntered: PropTypes.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'exit' class is
	   * applied.
	   *
	   * @type Function(node: HtmlElement)
	   */
	  onExit: PropTypes.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
	   *
	   * @type Function(node: HtmlElement
	   */
	  onExiting: PropTypes.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'exit' classes
	   * are **removed** and the `exit-done` class is added to the DOM node.
	   *
	   * @type Function(node: HtmlElement)
	   */
	  onExited: PropTypes.func
	});
	
	/**
	 * A `Transition` component using CSS transitions and animations.
	 * It's inspired by the excellent [ng-animate](http://www.nganimate.org/) library.
	 *
	 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
	 * and `exit` stages of the transition. The first class is applied and then a
	 * second "active" class in order to activate the css animation. After the animation,
	 * matching `done` class names are applied to persist the animation state.
	 *
	 * When the `in` prop is toggled to `true` the Component will get
	 * the `example-enter` CSS class and the `example-enter-active` CSS class
	 * added in the next tick. This is a convention based on the `classNames` prop.
	 *
	 * ## Example
	 *
	 * <iframe src="https://codesandbox.io/embed/m77l2vp00x?fontsize=14" style="width:100%; height:500px; border:0; border-radius: 4px; overflow:hidden;" sandbox="allow-modals allow-forms allow-popups allow-scripts allow-same-origin"></iframe>
	 */
	
	var CSSTransition = function (_React$Component) {
	  _inherits(CSSTransition, _React$Component);
	
	  function CSSTransition() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, CSSTransition);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.onEnter = function (node, appearing) {
	      var _this$getClassNames = _this.getClassNames(appearing ? 'appear' : 'enter'),
	          className = _this$getClassNames.className;
	
	      _this.removeClasses(node, 'exit');
	      addClass(node, className);
	
	      if (_this.props.onEnter) {
	        _this.props.onEnter(node);
	      }
	    }, _this.onEntering = function (node, appearing) {
	      var _this$getClassNames2 = _this.getClassNames(appearing ? 'appear' : 'enter'),
	          activeClassName = _this$getClassNames2.activeClassName;
	
	      _this.reflowAndAddClass(node, activeClassName);
	
	      if (_this.props.onEntering) {
	        _this.props.onEntering(node);
	      }
	    }, _this.onEntered = function (node, appearing) {
	      var _this$getClassNames3 = _this.getClassNames('enter'),
	          doneClassName = _this$getClassNames3.doneClassName;
	
	      _this.removeClasses(node, appearing ? 'appear' : 'enter');
	      addClass(node, doneClassName);
	
	      if (_this.props.onEntered) {
	        _this.props.onEntered(node);
	      }
	    }, _this.onExit = function (node) {
	      var _this$getClassNames4 = _this.getClassNames('exit'),
	          className = _this$getClassNames4.className;
	
	      _this.removeClasses(node, 'appear');
	      _this.removeClasses(node, 'enter');
	      addClass(node, className);
	
	      if (_this.props.onExit) {
	        _this.props.onExit(node);
	      }
	    }, _this.onExiting = function (node) {
	      var _this$getClassNames5 = _this.getClassNames('exit'),
	          activeClassName = _this$getClassNames5.activeClassName;
	
	      _this.reflowAndAddClass(node, activeClassName);
	
	      if (_this.props.onExiting) {
	        _this.props.onExiting(node);
	      }
	    }, _this.onExited = function (node) {
	      var _this$getClassNames6 = _this.getClassNames('exit'),
	          doneClassName = _this$getClassNames6.doneClassName;
	
	      _this.removeClasses(node, 'exit');
	      addClass(node, doneClassName);
	
	      if (_this.props.onExited) {
	        _this.props.onExited(node);
	      }
	    }, _this.getClassNames = function (type) {
	      var classNames = _this.props.classNames;
	
	
	      var className = typeof classNames !== 'string' ? classNames[type] : classNames + '-' + type;
	
	      var activeClassName = typeof classNames !== 'string' ? classNames[type + 'Active'] : className + '-active';
	
	      var doneClassName = typeof classNames !== 'string' ? classNames[type + 'Done'] : className + '-done';
	
	      return {
	        className: className,
	        activeClassName: activeClassName,
	        doneClassName: doneClassName
	      };
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  CSSTransition.prototype.removeClasses = function removeClasses(node, type) {
	    var _getClassNames = this.getClassNames(type),
	        className = _getClassNames.className,
	        activeClassName = _getClassNames.activeClassName,
	        doneClassName = _getClassNames.doneClassName;
	
	    className && removeClass(node, className);
	    activeClassName && removeClass(node, activeClassName);
	    doneClassName && removeClass(node, doneClassName);
	  };
	
	  CSSTransition.prototype.reflowAndAddClass = function reflowAndAddClass(node, className) {
	    // This is for to force a repaint,
	    // which is necessary in order to transition styles when adding a class name.
	    if (className) {
	      /* eslint-disable no-unused-expressions */
	      node && node.scrollTop;
	      /* eslint-enable no-unused-expressions */
	      addClass(node, className);
	    }
	  };
	
	  CSSTransition.prototype.render = function render() {
	    var props = _extends({}, this.props);
	
	    delete props.classNames;
	
	    return _react2.default.createElement(_Transition2.default, _extends({}, props, {
	      onEnter: this.onEnter,
	      onEntered: this.onEntered,
	      onEntering: this.onEntering,
	      onExit: this.onExit,
	      onExiting: this.onExiting,
	      onExited: this.onExited
	    }));
	  };
	
	  return CSSTransition;
	}(_react2.default.Component);
	
	CSSTransition.propTypes =  false ? propTypes : {};
	
	exports.default = CSSTransition;
	module.exports = exports['default'];

/***/ }),

/***/ 194:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(16);
	
	var _TransitionGroup = __webpack_require__(107);
	
	var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  in: _propTypes2.default.bool.isRequired,
	  children: function children(props, propName) {
	    if (_react2.default.Children.count(props[propName]) !== 2) return new Error('"' + propName + '" must be exactly two transition components.');
	
	    return null;
	  }
	};
	
	/**
	 * The `<ReplaceTransition>` component is a specialized `Transition` component
	 * that animates between two children.
	 *
	 * ```jsx
	 * <ReplaceTransition in>
	 *   <Fade><div>I appear first</div></Fade>
	 *   <Fade><div>I replace the above</div></Fade>
	 * </ReplaceTransition>
	 * ```
	 */
	
	var ReplaceTransition = function (_React$Component) {
	  _inherits(ReplaceTransition, _React$Component);
	
	  function ReplaceTransition() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ReplaceTransition);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  ReplaceTransition.prototype.handleLifecycle = function handleLifecycle(handler, idx, originalArgs) {
	    var _child$props;
	
	    var children = this.props.children;
	
	    var child = _react2.default.Children.toArray(children)[idx];
	
	    if (child.props[handler]) (_child$props = child.props)[handler].apply(_child$props, originalArgs);
	    if (this.props[handler]) this.props[handler]((0, _reactDom.findDOMNode)(this));
	  };
	
	  ReplaceTransition.prototype.render = function render() {
	    var _props = this.props,
	        children = _props.children,
	        inProp = _props.in,
	        props = _objectWithoutProperties(_props, ['children', 'in']);
	
	    var _React$Children$toArr = _react2.default.Children.toArray(children),
	        first = _React$Children$toArr[0],
	        second = _React$Children$toArr[1];
	
	    delete props.onEnter;
	    delete props.onEntering;
	    delete props.onEntered;
	    delete props.onExit;
	    delete props.onExiting;
	    delete props.onExited;
	
	    return _react2.default.createElement(
	      _TransitionGroup2.default,
	      props,
	      inProp ? _react2.default.cloneElement(first, {
	        key: 'first',
	        onEnter: this.handleEnter,
	        onEntering: this.handleEntering,
	        onEntered: this.handleEntered
	
	      }) : _react2.default.cloneElement(second, {
	        key: 'second',
	        onEnter: this.handleExit,
	        onEntering: this.handleExiting,
	        onEntered: this.handleExited
	      })
	    );
	  };
	
	  return ReplaceTransition;
	}(_react2.default.Component);
	
	var _initialiseProps = function _initialiseProps() {
	  var _this2 = this;
	
	  this.handleEnter = function () {
	    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      args[_key2] = arguments[_key2];
	    }
	
	    return _this2.handleLifecycle('onEnter', 0, args);
	  };
	
	  this.handleEntering = function () {
	    for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	      args[_key3] = arguments[_key3];
	    }
	
	    return _this2.handleLifecycle('onEntering', 0, args);
	  };
	
	  this.handleEntered = function () {
	    for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
	      args[_key4] = arguments[_key4];
	    }
	
	    return _this2.handleLifecycle('onEntered', 0, args);
	  };
	
	  this.handleExit = function () {
	    for (var _len5 = arguments.length, args = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
	      args[_key5] = arguments[_key5];
	    }
	
	    return _this2.handleLifecycle('onExit', 1, args);
	  };
	
	  this.handleExiting = function () {
	    for (var _len6 = arguments.length, args = Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
	      args[_key6] = arguments[_key6];
	    }
	
	    return _this2.handleLifecycle('onExiting', 1, args);
	  };
	
	  this.handleExited = function () {
	    for (var _len7 = arguments.length, args = Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
	      args[_key7] = arguments[_key7];
	    }
	
	    return _this2.handleLifecycle('onExited', 1, args);
	  };
	};
	
	ReplaceTransition.propTypes =  false ? propTypes : {};
	
	exports.default = ReplaceTransition;
	module.exports = exports['default'];

/***/ }),

/***/ 106:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = undefined;
	
	var _propTypes = __webpack_require__(3);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(16);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactLifecyclesCompat = __webpack_require__(90);
	
	var _PropTypes = __webpack_require__(108);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UNMOUNTED = exports.UNMOUNTED = 'unmounted';
	var EXITED = exports.EXITED = 'exited';
	var ENTERING = exports.ENTERING = 'entering';
	var ENTERED = exports.ENTERED = 'entered';
	var EXITING = exports.EXITING = 'exiting';
	
	/**
	 * The Transition component lets you describe a transition from one component
	 * state to another _over time_ with a simple declarative API. Most commonly
	 * it's used to animate the mounting and unmounting of a component, but can also
	 * be used to describe in-place transition states as well.
	 *
	 * By default the `Transition` component does not alter the behavior of the
	 * component it renders, it only tracks "enter" and "exit" states for the components.
	 * It's up to you to give meaning and effect to those states. For example we can
	 * add styles to a component when it enters or exits:
	 *
	 * ```jsx
	 * import Transition from 'react-transition-group/Transition';
	 *
	 * const duration = 300;
	 *
	 * const defaultStyle = {
	 *   transition: `opacity ${duration}ms ease-in-out`,
	 *   opacity: 0,
	 * }
	 *
	 * const transitionStyles = {
	 *   entering: { opacity: 0 },
	 *   entered:  { opacity: 1 },
	 * };
	 *
	 * const Fade = ({ in: inProp }) => (
	 *   <Transition in={inProp} timeout={duration}>
	 *     {(state) => (
	 *       <div style={{
	 *         ...defaultStyle,
	 *         ...transitionStyles[state]
	 *       }}>
	 *         I'm a fade Transition!
	 *       </div>
	 *     )}
	 *   </Transition>
	 * );
	 * ```
	 *
	 * As noted the `Transition` component doesn't _do_ anything by itself to its child component.
	 * What it does do is track transition states over time so you can update the
	 * component (such as by adding styles or classes) when it changes states.
	 *
	 * There are 4 main states a Transition can be in:
	 *  - `'entering'`
	 *  - `'entered'`
	 *  - `'exiting'`
	 *  - `'exited'`
	 *
	 * Transition state is toggled via the `in` prop. When `true` the component begins the
	 * "Enter" stage. During this stage, the component will shift from its current transition state,
	 * to `'entering'` for the duration of the transition and then to the `'entered'` stage once
	 * it's complete. Let's take the following example:
	 *
	 * ```jsx
	 * state = { in: false };
	 *
	 * toggleEnterState = () => {
	 *   this.setState({ in: true });
	 * }
	 *
	 * render() {
	 *   return (
	 *     <div>
	 *       <Transition in={this.state.in} timeout={500} />
	 *       <button onClick={this.toggleEnterState}>Click to Enter</button>
	 *     </div>
	 *   );
	 * }
	 * ```
	 *
	 * When the button is clicked the component will shift to the `'entering'` state and
	 * stay there for 500ms (the value of `timeout`) before it finally switches to `'entered'`.
	 *
	 * When `in` is `false` the same thing happens except the state moves from `'exiting'` to `'exited'`.
	 *
	 * ## Timing
	 *
	 * Timing is often the trickiest part of animation, mistakes can result in slight delays
	 * that are hard to pin down. A common example is when you want to add an exit transition,
	 * you should set the desired final styles when the state is `'exiting'`. That's when the
	 * transition to those styles will start and, if you matched the `timeout` prop with the
	 * CSS Transition duration, it will end exactly when the state changes to `'exited'`.
	 *
	 * > **Note**: For simpler transitions the `Transition` component might be enough, but
	 * > take into account that it's platform-agnostic, while the `CSSTransition` component
	 * > [forces reflows](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
	 * > in order to make more complex transitions more predictable. For example, even though
	 * > classes `example-enter` and `example-enter-active` are applied immediately one after
	 * > another, you can still transition from one to the other because of the forced reflow
	 * > (read [this issue](https://github.com/reactjs/react-transition-group/issues/159#issuecomment-322761171)
	 * > for more info). Take this into account when choosing between `Transition` and
	 * > `CSSTransition`.
	 *
	 * ## Example
	 *
	 * <iframe src="https://codesandbox.io/embed/741op4mmj0?fontsize=14" style="width:100%; height:500px; border:0; border-radius: 4px; overflow:hidden;" sandbox="allow-modals allow-forms allow-popups allow-scripts allow-same-origin"></iframe>
	 *
	 */
	
	var Transition = function (_React$Component) {
	  _inherits(Transition, _React$Component);
	
	  function Transition(props, context) {
	    _classCallCheck(this, Transition);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	    var parentGroup = context.transitionGroup;
	    // In the context of a TransitionGroup all enters are really appears
	    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
	
	    var initialStatus = void 0;
	
	    _this.appearStatus = null;
	
	    if (props.in) {
	      if (appear) {
	        initialStatus = EXITED;
	        _this.appearStatus = ENTERING;
	      } else {
	        initialStatus = ENTERED;
	      }
	    } else {
	      if (props.unmountOnExit || props.mountOnEnter) {
	        initialStatus = UNMOUNTED;
	      } else {
	        initialStatus = EXITED;
	      }
	    }
	
	    _this.state = { status: initialStatus };
	
	    _this.nextCallback = null;
	    return _this;
	  }
	
	  Transition.prototype.getChildContext = function getChildContext() {
	    return { transitionGroup: null // allows for nested Transitions
	    };
	  };
	
	  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
	    var nextIn = _ref.in;
	
	    if (nextIn && prevState.status === UNMOUNTED) {
	      return { status: EXITED };
	    }
	    return null;
	  };
	
	  // getSnapshotBeforeUpdate(prevProps) {
	  //   let nextStatus = null
	
	  //   if (prevProps !== this.props) {
	  //     const { status } = this.state
	
	  //     if (this.props.in) {
	  //       if (status !== ENTERING && status !== ENTERED) {
	  //         nextStatus = ENTERING
	  //       }
	  //     } else {
	  //       if (status === ENTERING || status === ENTERED) {
	  //         nextStatus = EXITING
	  //       }
	  //     }
	  //   }
	
	  //   return { nextStatus }
	  // }
	
	  Transition.prototype.componentDidMount = function componentDidMount() {
	    this.updateStatus(true, this.appearStatus);
	  };
	
	  Transition.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    var nextStatus = null;
	    if (prevProps !== this.props) {
	      var status = this.state.status;
	
	
	      if (this.props.in) {
	        if (status !== ENTERING && status !== ENTERED) {
	          nextStatus = ENTERING;
	        }
	      } else {
	        if (status === ENTERING || status === ENTERED) {
	          nextStatus = EXITING;
	        }
	      }
	    }
	    this.updateStatus(false, nextStatus);
	  };
	
	  Transition.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.cancelNextCallback();
	  };
	
	  Transition.prototype.getTimeouts = function getTimeouts() {
	    var timeout = this.props.timeout;
	
	    var exit = void 0,
	        enter = void 0,
	        appear = void 0;
	
	    exit = enter = appear = timeout;
	
	    if (timeout != null && typeof timeout !== 'number') {
	      exit = timeout.exit;
	      enter = timeout.enter;
	      appear = timeout.appear;
	    }
	    return { exit: exit, enter: enter, appear: appear };
	  };
	
	  Transition.prototype.updateStatus = function updateStatus() {
	    var mounting = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	    var nextStatus = arguments[1];
	
	    if (nextStatus !== null) {
	      // nextStatus will always be ENTERING or EXITING.
	      this.cancelNextCallback();
	      var node = _reactDom2.default.findDOMNode(this);
	
	      if (nextStatus === ENTERING) {
	        this.performEnter(node, mounting);
	      } else {
	        this.performExit(node);
	      }
	    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
	      this.setState({ status: UNMOUNTED });
	    }
	  };
	
	  Transition.prototype.performEnter = function performEnter(node, mounting) {
	    var _this2 = this;
	
	    var enter = this.props.enter;
	
	    var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;
	
	    var timeouts = this.getTimeouts();
	
	    // no enter animation skip right to ENTERED
	    // if we are mounting and running this it means appear _must_ be set
	    if (!mounting && !enter) {
	      this.safeSetState({ status: ENTERED }, function () {
	        _this2.props.onEntered(node);
	      });
	      return;
	    }
	
	    this.props.onEnter(node, appearing);
	
	    this.safeSetState({ status: ENTERING }, function () {
	      _this2.props.onEntering(node, appearing);
	
	      // FIXME: appear timeout?
	      _this2.onTransitionEnd(node, timeouts.enter, function () {
	        _this2.safeSetState({ status: ENTERED }, function () {
	          _this2.props.onEntered(node, appearing);
	        });
	      });
	    });
	  };
	
	  Transition.prototype.performExit = function performExit(node) {
	    var _this3 = this;
	
	    var exit = this.props.exit;
	
	    var timeouts = this.getTimeouts();
	
	    // no exit animation skip right to EXITED
	    if (!exit) {
	      this.safeSetState({ status: EXITED }, function () {
	        _this3.props.onExited(node);
	      });
	      return;
	    }
	    this.props.onExit(node);
	
	    this.safeSetState({ status: EXITING }, function () {
	      _this3.props.onExiting(node);
	
	      _this3.onTransitionEnd(node, timeouts.exit, function () {
	        _this3.safeSetState({ status: EXITED }, function () {
	          _this3.props.onExited(node);
	        });
	      });
	    });
	  };
	
	  Transition.prototype.cancelNextCallback = function cancelNextCallback() {
	    if (this.nextCallback !== null) {
	      this.nextCallback.cancel();
	      this.nextCallback = null;
	    }
	  };
	
	  Transition.prototype.safeSetState = function safeSetState(nextState, callback) {
	    // This shouldn't be necessary, but there are weird race conditions with
	    // setState callbacks and unmounting in testing, so always make sure that
	    // we can cancel any pending setState callbacks after we unmount.
	    callback = this.setNextCallback(callback);
	    this.setState(nextState, callback);
	  };
	
	  Transition.prototype.setNextCallback = function setNextCallback(callback) {
	    var _this4 = this;
	
	    var active = true;
	
	    this.nextCallback = function (event) {
	      if (active) {
	        active = false;
	        _this4.nextCallback = null;
	
	        callback(event);
	      }
	    };
	
	    this.nextCallback.cancel = function () {
	      active = false;
	    };
	
	    return this.nextCallback;
	  };
	
	  Transition.prototype.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
	    this.setNextCallback(handler);
	
	    if (node) {
	      if (this.props.addEndListener) {
	        this.props.addEndListener(node, this.nextCallback);
	      }
	      if (timeout != null) {
	        setTimeout(this.nextCallback, timeout);
	      }
	    } else {
	      setTimeout(this.nextCallback, 0);
	    }
	  };
	
	  Transition.prototype.render = function render() {
	    var status = this.state.status;
	    if (status === UNMOUNTED) {
	      return null;
	    }
	
	    var _props = this.props,
	        children = _props.children,
	        childProps = _objectWithoutProperties(_props, ['children']);
	    // filter props for Transtition
	
	
	    delete childProps.in;
	    delete childProps.mountOnEnter;
	    delete childProps.unmountOnExit;
	    delete childProps.appear;
	    delete childProps.enter;
	    delete childProps.exit;
	    delete childProps.timeout;
	    delete childProps.addEndListener;
	    delete childProps.onEnter;
	    delete childProps.onEntering;
	    delete childProps.onEntered;
	    delete childProps.onExit;
	    delete childProps.onExiting;
	    delete childProps.onExited;
	
	    if (typeof children === 'function') {
	      return children(status, childProps);
	    }
	
	    var child = _react2.default.Children.only(children);
	    return _react2.default.cloneElement(child, childProps);
	  };
	
	  return Transition;
	}(_react2.default.Component);
	
	Transition.contextTypes = {
	  transitionGroup: PropTypes.object
	};
	Transition.childContextTypes = {
	  transitionGroup: function transitionGroup() {}
	};
	
	
	Transition.propTypes =  false ? {
	  /**
	   * A `function` child can be used instead of a React element.
	   * This function is called with the current transition status
	   * ('entering', 'entered', 'exiting', 'exited', 'unmounted'), which can be used
	   * to apply context specific props to a component.
	   *
	   * ```jsx
	   * <Transition timeout={150}>
	   *   {(status) => (
	   *     <MyComponent className={`fade fade-${status}`} />
	   *   )}
	   * </Transition>
	   * ```
	   */
	  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,
	
	  /**
	   * Show the component; triggers the enter or exit states
	   */
	  in: PropTypes.bool,
	
	  /**
	   * By default the child component is mounted immediately along with
	   * the parent `Transition` component. If you want to "lazy mount" the component on the
	   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
	   * mounted, even on "exited", unless you also specify `unmountOnExit`.
	   */
	  mountOnEnter: PropTypes.bool,
	
	  /**
	   * By default the child component stays mounted after it reaches the `'exited'` state.
	   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
	   */
	  unmountOnExit: PropTypes.bool,
	
	  /**
	   * Normally a component is not transitioned if it is shown when the `<Transition>` component mounts.
	   * If you want to transition on the first mount set `appear` to `true`, and the
	   * component will transition in as soon as the `<Transition>` mounts.
	   *
	   * > Note: there are no specific "appear" states. `appear` only adds an additional `enter` transition.
	   */
	  appear: PropTypes.bool,
	
	  /**
	   * Enable or disable enter transitions.
	   */
	  enter: PropTypes.bool,
	
	  /**
	   * Enable or disable exit transitions.
	   */
	  exit: PropTypes.bool,
	
	  /**
	   * The duration of the transition, in milliseconds.
	   * Required unless `addEndListener` is provided
	   *
	   * You may specify a single timeout for all transitions like: `timeout={500}`,
	   * or individually like:
	   *
	   * ```jsx
	   * timeout={{
	   *  enter: 300,
	   *  exit: 500,
	   * }}
	   * ```
	   *
	   * @type {number | { enter?: number, exit?: number }}
	   */
	  timeout: function timeout(props) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var pt = _PropTypes.timeoutsShape;
	    if (!props.addEndListener) pt = pt.isRequired;
	    return pt.apply(undefined, [props].concat(args));
	  },
	
	  /**
	   * Add a custom transition end trigger. Called with the transitioning
	   * DOM node and a `done` callback. Allows for more fine grained transition end
	   * logic. **Note:** Timeouts are still used as a fallback if provided.
	   *
	   * ```jsx
	   * addEndListener={(node, done) => {
	   *   // use the css transitionend event to mark the finish of a transition
	   *   node.addEventListener('transitionend', done, false);
	   * }}
	   * ```
	   */
	  addEndListener: PropTypes.func,
	
	  /**
	   * Callback fired before the "entering" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool) -> void
	   */
	  onEnter: PropTypes.func,
	
	  /**
	   * Callback fired after the "entering" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEntering: PropTypes.func,
	
	  /**
	   * Callback fired after the "entered" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool) -> void
	   */
	  onEntered: PropTypes.func,
	
	  /**
	   * Callback fired before the "exiting" status is applied.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExit: PropTypes.func,
	
	  /**
	   * Callback fired after the "exiting" status is applied.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExiting: PropTypes.func,
	
	  /**
	   * Callback fired after the "exited" status is applied.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExited: PropTypes.func
	
	  // Name the function so it is clearer in the documentation
	} : {};function noop() {}
	
	Transition.defaultProps = {
	  in: false,
	  mountOnEnter: false,
	  unmountOnExit: false,
	  appear: false,
	  enter: true,
	  exit: true,
	
	  onEnter: noop,
	  onEntering: noop,
	  onEntered: noop,
	
	  onExit: noop,
	  onExiting: noop,
	  onExited: noop
	};
	
	Transition.UNMOUNTED = 0;
	Transition.EXITED = 1;
	Transition.ENTERING = 2;
	Transition.ENTERED = 3;
	Transition.EXITING = 4;
	
	exports.default = (0, _reactLifecyclesCompat.polyfill)(Transition);

/***/ }),

/***/ 107:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactLifecyclesCompat = __webpack_require__(90);
	
	var _ChildMapping = __webpack_require__(195);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var values = Object.values || function (obj) {
	  return Object.keys(obj).map(function (k) {
	    return obj[k];
	  });
	};
	
	var propTypes = {
	  /**
	   * `<TransitionGroup>` renders a `<div>` by default. You can change this
	   * behavior by providing a `component` prop.
	   * If you use React v16+ and would like to avoid a wrapping `<div>` element
	   * you can pass in `component={null}`. This is useful if the wrapping div
	   * borks your css styles.
	   */
	  component: _propTypes2.default.any,
	  /**
	   * A set of `<Transition>` components, that are toggled `in` and out as they
	   * leave. the `<TransitionGroup>` will inject specific transition props, so
	   * remember to spread them through if you are wrapping the `<Transition>` as
	   * with our `<Fade>` example.
	   */
	  children: _propTypes2.default.node,
	
	  /**
	   * A convenience prop that enables or disables appear animations
	   * for all children. Note that specifying this will override any defaults set
	   * on individual children Transitions.
	   */
	  appear: _propTypes2.default.bool,
	  /**
	   * A convenience prop that enables or disables enter animations
	   * for all children. Note that specifying this will override any defaults set
	   * on individual children Transitions.
	   */
	  enter: _propTypes2.default.bool,
	  /**
	   * A convenience prop that enables or disables exit animations
	   * for all children. Note that specifying this will override any defaults set
	   * on individual children Transitions.
	   */
	  exit: _propTypes2.default.bool,
	
	  /**
	   * You may need to apply reactive updates to a child as it is exiting.
	   * This is generally done by using `cloneElement` however in the case of an exiting
	   * child the element has already been removed and not accessible to the consumer.
	   *
	   * If you do need to update a child as it leaves you can provide a `childFactory`
	   * to wrap every child, even the ones that are leaving.
	   *
	   * @type Function(child: ReactElement) -> ReactElement
	   */
	  childFactory: _propTypes2.default.func
	};
	
	var defaultProps = {
	  component: 'div',
	  childFactory: function childFactory(child) {
	    return child;
	  }
	
	  /**
	   * The `<TransitionGroup>` component manages a set of `<Transition>` components
	   * in a list. Like with the `<Transition>` component, `<TransitionGroup>`, is a
	   * state machine for managing the mounting and unmounting of components over
	   * time.
	   *
	   * Consider the example below using the `Fade` CSS transition from before.
	   * As items are removed or added to the TodoList the `in` prop is toggled
	   * automatically by the `<TransitionGroup>`. You can use _any_ `<Transition>`
	   * component in a `<TransitionGroup>`, not just css.
	   *
	   * ## Example
	   *
	   * <iframe src="https://codesandbox.io/embed/00rqyo26kn?fontsize=14" style="width:100%; height:500px; border:0; border-radius: 4px; overflow:hidden;" sandbox="allow-modals allow-forms allow-popups allow-scripts allow-same-origin"></iframe>
	   *
	   * Note that `<TransitionGroup>`  does not define any animation behavior!
	   * Exactly _how_ a list item animates is up to the individual `<Transition>`
	   * components. This means you can mix and match animations across different
	   * list items.
	   */
	};
	var TransitionGroup = function (_React$Component) {
	  _inherits(TransitionGroup, _React$Component);
	
	  function TransitionGroup(props, context) {
	    _classCallCheck(this, TransitionGroup);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	    var handleExited = _this.handleExited.bind(_this);
	
	    // Initial children should all be entering, dependent on appear
	    _this.state = {
	      handleExited: handleExited,
	      firstRender: true
	    };
	    return _this;
	  }
	
	  TransitionGroup.prototype.getChildContext = function getChildContext() {
	    return {
	      transitionGroup: { isMounting: !this.appeared }
	    };
	  };
	
	  TransitionGroup.prototype.componentDidMount = function componentDidMount() {
	    this.appeared = true;
	  };
	
	  TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
	    var prevChildMapping = _ref.children,
	        handleExited = _ref.handleExited,
	        firstRender = _ref.firstRender;
	
	    return {
	      children: firstRender ? (0, _ChildMapping.getInitialChildMapping)(nextProps, handleExited) : (0, _ChildMapping.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
	      firstRender: false
	    };
	  };
	
	  TransitionGroup.prototype.handleExited = function handleExited(child, node) {
	    var currentChildMapping = (0, _ChildMapping.getChildMapping)(this.props.children);
	
	    if (child.key in currentChildMapping) return;
	
	    if (child.props.onExited) {
	      child.props.onExited(node);
	    }
	
	    this.setState(function (state) {
	      var children = _extends({}, state.children);
	
	      delete children[child.key];
	      return { children: children };
	    });
	  };
	
	  TransitionGroup.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.component,
	        childFactory = _props.childFactory,
	        props = _objectWithoutProperties(_props, ['component', 'childFactory']);
	
	    var children = values(this.state.children).map(childFactory);
	
	    delete props.appear;
	    delete props.enter;
	    delete props.exit;
	
	    if (Component === null) {
	      return children;
	    }
	    return _react2.default.createElement(
	      Component,
	      props,
	      children
	    );
	  };
	
	  return TransitionGroup;
	}(_react2.default.Component);
	
	TransitionGroup.childContextTypes = {
	  transitionGroup: _propTypes2.default.object.isRequired
	};
	
	
	TransitionGroup.propTypes =  false ? propTypes : {};
	TransitionGroup.defaultProps = defaultProps;
	
	exports.default = (0, _reactLifecyclesCompat.polyfill)(TransitionGroup);
	module.exports = exports['default'];

/***/ }),

/***/ 138:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _CSSTransition = __webpack_require__(193);
	
	var _CSSTransition2 = _interopRequireDefault(_CSSTransition);
	
	var _ReplaceTransition = __webpack_require__(194);
	
	var _ReplaceTransition2 = _interopRequireDefault(_ReplaceTransition);
	
	var _TransitionGroup = __webpack_require__(107);
	
	var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);
	
	var _Transition = __webpack_require__(106);
	
	var _Transition2 = _interopRequireDefault(_Transition);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = {
	  Transition: _Transition2.default,
	  TransitionGroup: _TransitionGroup2.default,
	  ReplaceTransition: _ReplaceTransition2.default,
	  CSSTransition: _CSSTransition2.default
	};

/***/ }),

/***/ 195:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.getChildMapping = getChildMapping;
	exports.mergeChildMappings = mergeChildMappings;
	exports.getInitialChildMapping = getInitialChildMapping;
	exports.getNextChildMapping = getNextChildMapping;
	
	var _react = __webpack_require__(1);
	
	/**
	 * Given `this.props.children`, return an object mapping key to child.
	 *
	 * @param {*} children `this.props.children`
	 * @return {object} Mapping of key to child
	 */
	function getChildMapping(children, mapFn) {
	  var mapper = function mapper(child) {
	    return mapFn && (0, _react.isValidElement)(child) ? mapFn(child) : child;
	  };
	
	  var result = Object.create(null);
	  if (children) _react.Children.map(children, function (c) {
	    return c;
	  }).forEach(function (child) {
	    // run the map function here instead so that the key is the computed one
	    result[child.key] = mapper(child);
	  });
	  return result;
	}
	
	/**
	 * When you're adding or removing children some may be added or removed in the
	 * same render pass. We want to show *both* since we want to simultaneously
	 * animate elements in and out. This function takes a previous set of keys
	 * and a new set of keys and merges them with its best guess of the correct
	 * ordering. In the future we may expose some of the utilities in
	 * ReactMultiChild to make this easy, but for now React itself does not
	 * directly have this concept of the union of prevChildren and nextChildren
	 * so we implement it here.
	 *
	 * @param {object} prev prev children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @param {object} next next children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @return {object} a key set that contains all keys in `prev` and all keys
	 * in `next` in a reasonable order.
	 */
	function mergeChildMappings(prev, next) {
	  prev = prev || {};
	  next = next || {};
	
	  function getValueForKey(key) {
	    return key in next ? next[key] : prev[key];
	  }
	
	  // For each key of `next`, the list of keys to insert before that key in
	  // the combined list
	  var nextKeysPending = Object.create(null);
	
	  var pendingKeys = [];
	  for (var prevKey in prev) {
	    if (prevKey in next) {
	      if (pendingKeys.length) {
	        nextKeysPending[prevKey] = pendingKeys;
	        pendingKeys = [];
	      }
	    } else {
	      pendingKeys.push(prevKey);
	    }
	  }
	
	  var i = void 0;
	  var childMapping = {};
	  for (var nextKey in next) {
	    if (nextKeysPending[nextKey]) {
	      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
	        var pendingNextKey = nextKeysPending[nextKey][i];
	        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
	      }
	    }
	    childMapping[nextKey] = getValueForKey(nextKey);
	  }
	
	  // Finally, add the keys which didn't appear before any key in `next`
	  for (i = 0; i < pendingKeys.length; i++) {
	    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
	  }
	
	  return childMapping;
	}
	
	function getProp(child, prop, props) {
	  return props[prop] != null ? props[prop] : child.props[prop];
	}
	
	function getInitialChildMapping(props, onExited) {
	  return getChildMapping(props.children, function (child) {
	    return (0, _react.cloneElement)(child, {
	      onExited: onExited.bind(null, child),
	      in: true,
	      appear: getProp(child, 'appear', props),
	      enter: getProp(child, 'enter', props),
	      exit: getProp(child, 'exit', props)
	    });
	  });
	}
	
	function getNextChildMapping(nextProps, prevChildMapping, onExited) {
	  var nextChildMapping = getChildMapping(nextProps.children);
	  var children = mergeChildMappings(prevChildMapping, nextChildMapping);
	
	  Object.keys(children).forEach(function (key) {
	    var child = children[key];
	
	    if (!(0, _react.isValidElement)(child)) return;
	
	    var hasPrev = key in prevChildMapping;
	    var hasNext = key in nextChildMapping;
	
	    var prevChild = prevChildMapping[key];
	    var isLeaving = (0, _react.isValidElement)(prevChild) && !prevChild.props.in;
	
	    // item is new (entering)
	    if (hasNext && (!hasPrev || isLeaving)) {
	      // console.log('entering', key)
	      children[key] = (0, _react.cloneElement)(child, {
	        onExited: onExited.bind(null, child),
	        in: true,
	        exit: getProp(child, 'exit', nextProps),
	        enter: getProp(child, 'enter', nextProps)
	      });
	    } else if (!hasNext && hasPrev && !isLeaving) {
	      // item is old (exiting)
	      // console.log('leaving', key)
	      children[key] = (0, _react.cloneElement)(child, { in: false });
	    } else if (hasNext && hasPrev && (0, _react.isValidElement)(prevChild)) {
	      // item hasn't changed transition states
	      // copy over the last transition props;
	      // console.log('unchanged', key)
	      children[key] = (0, _react.cloneElement)(child, {
	        onExited: onExited.bind(null, child),
	        in: prevChild.props.in,
	        exit: getProp(child, 'exit', nextProps),
	        enter: getProp(child, 'enter', nextProps)
	      });
	    }
	  });
	
	  return children;
	}

/***/ }),

/***/ 108:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.classNamesShape = exports.timeoutsShape = undefined;
	exports.transitionTimeout = transitionTimeout;
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function transitionTimeout(transitionType) {
	  var timeoutPropName = 'transition' + transitionType + 'Timeout';
	  var enabledPropName = 'transition' + transitionType;
	
	  return function (props) {
	    // If the transition is enabled
	    if (props[enabledPropName]) {
	      // If no timeout duration is provided
	      if (props[timeoutPropName] == null) {
	        return new Error(timeoutPropName + ' wasn\'t supplied to CSSTransitionGroup: ' + 'this can cause unreliable animations and won\'t be supported in ' + 'a future version of React. See ' + 'https://fb.me/react-animation-transition-group-timeout for more ' + 'information.');
	
	        // If the duration isn't a number
	      } else if (typeof props[timeoutPropName] !== 'number') {
	        return new Error(timeoutPropName + ' must be a number (in milliseconds)');
	      }
	    }
	
	    return null;
	  };
	}
	
	var timeoutsShape = exports.timeoutsShape = _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.shape({
	  enter: _propTypes2.default.number,
	  exit: _propTypes2.default.number
	}).isRequired]);
	
	var classNamesShape = exports.classNamesShape = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
	  enter: _propTypes2.default.string,
	  exit: _propTypes2.default.string,
	  active: _propTypes2.default.string
	}), _propTypes2.default.shape({
	  enter: _propTypes2.default.string,
	  enterDone: _propTypes2.default.string,
	  enterActive: _propTypes2.default.string,
	  exit: _propTypes2.default.string,
	  exitDone: _propTypes2.default.string,
	  exitActive: _propTypes2.default.string
	})]);

/***/ }),

/***/ 730:
/***/ (function(module, exports, __webpack_require__) {

	var noCase = __webpack_require__(28)
	var upperCaseFirst = __webpack_require__(196)
	
	/**
	 * Sentence case a string.
	 *
	 * @param  {string} value
	 * @param  {string} [locale]
	 * @return {string}
	 */
	module.exports = function (value, locale) {
	  return upperCaseFirst(noCase(value, locale), locale)
	}


/***/ }),

/***/ 279:
/***/ (function(module, exports, __webpack_require__) {

	var noCase = __webpack_require__(28)
	
	/**
	 * Snake case a string.
	 *
	 * @param  {string} value
	 * @param  {string} [locale]
	 * @return {string}
	 */
	module.exports = function (value, locale) {
	  return noCase(value, locale, '_')
	}


/***/ }),

/***/ 733:
/***/ (function(module, exports, __webpack_require__) {

	var upperCase = __webpack_require__(37)
	var lowerCase = __webpack_require__(81)
	
	/**
	 * Swap the case of a string. Manually iterate over every character and check
	 * instead of replacing certain characters for better unicode support.
	 *
	 * @param  {String} str
	 * @param  {String} [locale]
	 * @return {String}
	 */
	module.exports = function (str, locale) {
	  if (str == null) {
	    return ''
	  }
	
	  var result = ''
	
	  for (var i = 0; i < str.length; i++) {
	    var c = str[i]
	    var u = upperCase(c, locale)
	
	    result += u === c ? lowerCase(c, locale) : u
	  }
	
	  return result
	}


/***/ }),

/***/ 734:
/***/ (function(module, exports, __webpack_require__) {

	var noCase = __webpack_require__(28)
	var upperCase = __webpack_require__(37)
	
	/**
	 * Title case a string.
	 *
	 * @param  {string} value
	 * @param  {string} [locale]
	 * @return {string}
	 */
	module.exports = function (value, locale) {
	  return noCase(value, locale).replace(/^.| ./g, function (m) {
	    return upperCase(m, locale)
	  })
	}


/***/ }),

/***/ 196:
/***/ (function(module, exports, __webpack_require__) {

	var upperCase = __webpack_require__(37)
	
	/**
	 * Upper case the first character of a string.
	 *
	 * @param  {String} str
	 * @return {String}
	 */
	module.exports = function (str, locale) {
	  if (str == null) {
	    return ''
	  }
	
	  str = String(str)
	
	  return upperCase(str.charAt(0), locale) + str.substr(1)
	}


/***/ }),

/***/ 37:
/***/ (function(module, exports) {

	/**
	 * Special language-specific overrides.
	 *
	 * Source: ftp://ftp.unicode.org/Public/UCD/latest/ucd/SpecialCasing.txt
	 *
	 * @type {Object}
	 */
	var LANGUAGES = {
	  tr: {
	    regexp: /[\u0069]/g,
	    map: {
	      '\u0069': '\u0130'
	    }
	  },
	  az: {
	    regexp: /[\u0069]/g,
	    map: {
	      '\u0069': '\u0130'
	    }
	  },
	  lt: {
	    regexp: /[\u0069\u006A\u012F]\u0307|\u0069\u0307[\u0300\u0301\u0303]/g,
	    map: {
	      '\u0069\u0307': '\u0049',
	      '\u006A\u0307': '\u004A',
	      '\u012F\u0307': '\u012E',
	      '\u0069\u0307\u0300': '\u00CC',
	      '\u0069\u0307\u0301': '\u00CD',
	      '\u0069\u0307\u0303': '\u0128'
	    }
	  }
	}
	
	/**
	 * Upper case a string.
	 *
	 * @param  {String} str
	 * @return {String}
	 */
	module.exports = function (str, locale) {
	  var lang = LANGUAGES[locale]
	
	  str = str == null ? '' : String(str)
	
	  if (lang) {
	    str = str.replace(lang.regexp, function (m) { return lang.map[m] })
	  }
	
	  return str.toUpperCase()
	}


/***/ }),

/***/ 291:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyImage = __webpack_require__(18);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	__webpack_require__(592);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Footer = function (_Component) {
	  _inherits(Footer, _Component);
	
	  function Footer() {
	    _classCallCheck(this, Footer);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  Footer.prototype.render = function render() {
	    var logoLugerna = this.props.images.find(function (image) {
	      return image.node.sizes.src.indexOf('footer-lugerna') >= 0;
	    });
	    var logoUsi = this.props.images.find(function (image) {
	      return image.node.sizes.src.indexOf('footer-usi') >= 0;
	    });
	    var logoAdm = this.props.images.find(function (image) {
	      return image.node.sizes.src.indexOf('footer-adm') >= 0;
	    });
	    var logoSorbonne = this.props.images.find(function (image) {
	      return image.node.sizes.src.indexOf('footer-sorbonne') >= 0;
	    });
	    var logoUnimilano = this.props.images.find(function (image) {
	      return image.node.sizes.src.indexOf('footer-uniMilano') >= 0;
	    });
	    var logoCattolica = this.props.images.find(function (image) {
	      return image.node.sizes.src.indexOf('footer-cattolica') >= 0;
	    });
	    var logoPolitecnico = this.props.images.find(function (image) {
	      return image.node.sizes.src.indexOf('footer-politecnico') >= 0;
	    });
	    var logoInnsbruck = this.props.images.find(function (image) {
	      return image.node.sizes.src.indexOf('footer-innsbruck') >= 0;
	    });
	    var logoFns = this.props.images.find(function (image) {
	      return image.node.sizes.src.indexOf('footer-centraleFns') >= 0;
	    });
	    var logoOaw = this.props.images.find(function (image) {
	      return image.node.sizes.src.indexOf('footer-oaw') >= 0;
	    });
	
	    return _react2.default.createElement(
	      'footer',
	      { className: 'Footer' },
	      _react2.default.createElement(
	        'div',
	        { className: 'Footer__Mobile' },
	        _react2.default.createElement(
	          'div',
	          { className: 'Footer__Section--mobile' },
	          _react2.default.createElement(
	            'div',
	            { className: 'Footer__Mobile__Row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'LogoPrimaRiga', style: { flex: 1 } },
	              _react2.default.createElement(_gatsbyImage2.default, { sizes: logoUsi.node.sizes })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'LogoPrimaRiga', style: { flex: 2 } },
	              _react2.default.createElement(_gatsbyImage2.default, { sizes: logoAdm.node.sizes })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'Footer__Mobile__Row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'LogoPrimaRiga', style: { flex: 1 } },
	              _react2.default.createElement(_gatsbyImage2.default, { sizes: logoLugerna.node.sizes })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'LogoPrimaRiga', style: { flex: 2 } },
	              _react2.default.createElement(_gatsbyImage2.default, { sizes: logoSorbonne.node.sizes })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'Footer__Section--mobile' },
	          _react2.default.createElement(
	            'div',
	            {
	              style: {
	                margin: '0 auto',
	                width: '300px'
	              }
	            },
	            _react2.default.createElement(
	              'div',
	              { className: 'Footer__Heading' },
	              'Contatti'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'text-white' },
	              _react2.default.createElement(
	                'div',
	                null,
	                'Telefono: + 4 1 58 666 55 00'
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                'Mail: archivio.arc@usi.ch'
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                'Website: www.archiviodelmoderno.org'
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                'Via Magazzini Generali 14'
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                '6828 Balerna (Svizzera)'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'Footer__Heading', style: { marginTop: '2rem' } },
	              'Partner'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'Footer__Partner__Row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'LogoPrimaRiga', style: { flex: 3 } },
	                _react2.default.createElement(_gatsbyImage2.default, { sizes: logoUnimilano.node.sizes })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'LogoPrimaRiga', style: { flex: 1 } },
	                _react2.default.createElement(_gatsbyImage2.default, { sizes: logoCattolica.node.sizes })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              {
	                className: 'Footer__Partner__Row',
	                style: { justifyContent: 'start' }
	              },
	              _react2.default.createElement(
	                'div',
	                { className: 'LogoPrimaRiga', style: { flex: 3 } },
	                _react2.default.createElement(_gatsbyImage2.default, { sizes: logoPolitecnico.node.sizes })
	              ),
	              _react2.default.createElement('div', { style: { flex: 1 } })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'Footer__Partner__Row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'LogoPrimaRiga', style: { flex: 1 } },
	                _react2.default.createElement(_gatsbyImage2.default, { sizes: logoOaw.node.sizes })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'LogoPrimaRiga', style: { flex: 3 } },
	                _react2.default.createElement(_gatsbyImage2.default, { sizes: logoInnsbruck.node.sizes })
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'Footer__Section--mobile' },
	          _react2.default.createElement(
	            'div',
	            {
	              className: 'LogoPrimaRiga',
	              style: { width: '300px', margin: '0 auto' }
	            },
	            _react2.default.createElement(_gatsbyImage2.default, { sizes: logoFns.node.sizes })
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'Footer__Desktop' },
	        _react2.default.createElement(
	          'div',
	          { className: 'Footer__Section' },
	          _react2.default.createElement(
	            'div',
	            { className: 'wrap-narrower Footer__LoghiPrimaRiga' },
	            _react2.default.createElement(
	              'div',
	              { className: 'LogoPrimaRiga', style: { flex: 1 } },
	              _react2.default.createElement(_gatsbyImage2.default, {
	                sizes: logoUsi.node.sizes,
	                imgStyle: {
	                  bottom: 0,
	                  top: 'auto',
	                  height: '74%',
	                  width: 'auto'
	                }
	              })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'LogoPrimaRiga', style: { flex: 2 } },
	              _react2.default.createElement(_gatsbyImage2.default, { sizes: logoAdm.node.sizes })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'LogoPrimaRiga', style: { flex: 1 } },
	              _react2.default.createElement(_gatsbyImage2.default, {
	                sizes: logoLugerna.node.sizes,
	                imgStyle: {
	                  width: '90%',
	                  height: 'auto'
	                }
	              })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'LogoPrimaRiga', style: { flex: 2 } },
	              _react2.default.createElement(_gatsbyImage2.default, { sizes: logoSorbonne.node.sizes })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'Footer__Section' },
	          _react2.default.createElement(
	            'div',
	            { className: 'wrap-narrower' },
	            _react2.default.createElement(
	              'div',
	              { className: 'Footer__Row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'Footer__Left' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'Footer__Heading' },
	                  'Contatti'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'text-white' },
	                  _react2.default.createElement(
	                    'div',
	                    null,
	                    'Telefono: + 4 1 58 666 55 00'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    null,
	                    'Mail: archivio.arc@usi.ch'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    null,
	                    'Website: www.archiviodelmoderno.org'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    null,
	                    'Via Magazzini Generali 14'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    null,
	                    '6828 Balerna (Svizzera)'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'Footer__Right Footer__Partner' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'Footer__Heading' },
	                  'Partner'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'Footer__Partner__Row' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'LogoPrimaRiga', style: { flex: 3 } },
	                    _react2.default.createElement(_gatsbyImage2.default, { sizes: logoUnimilano.node.sizes })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'LogoPrimaRiga', style: { flex: 1 } },
	                    _react2.default.createElement(_gatsbyImage2.default, {
	                      sizes: logoCattolica.node.sizes,
	                      imgStyle: {
	                        height: '90%',
	                        width: 'auto'
	                      }
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  {
	                    className: 'Footer__Partner__Row',
	                    style: { justifyContent: 'start' }
	                  },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'LogoPrimaRiga', style: { flex: 3 } },
	                    _react2.default.createElement(_gatsbyImage2.default, { sizes: logoPolitecnico.node.sizes })
	                  ),
	                  _react2.default.createElement('div', { style: { flex: 1 } })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'Footer__Partner__Row' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'LogoPrimaRiga', style: { flex: 1 } },
	                    _react2.default.createElement(_gatsbyImage2.default, { sizes: logoOaw.node.sizes })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'LogoPrimaRiga', style: { flex: 3 } },
	                    _react2.default.createElement(_gatsbyImage2.default, { sizes: logoInnsbruck.node.sizes })
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'Footer__Section', style: { padding: '4rem' } },
	          _react2.default.createElement(
	            'div',
	            { className: 'wrap-narrower Footer__Row' },
	            _react2.default.createElement('div', { style: { flex: 1 } }),
	            _react2.default.createElement(
	              'div',
	              { className: 'LogoPrimaRiga', style: { flex: 1 } },
	              _react2.default.createElement(_gatsbyImage2.default, { sizes: logoFns.node.sizes })
	            ),
	            _react2.default.createElement('div', { style: { flex: 1 } })
	          )
	        )
	      )
	    );
	  };
	
	  return Footer;
	}(_react.Component);
	
	exports.default = Footer;
	module.exports = exports['default'];

/***/ }),

/***/ 592:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 292:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(25);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _gatsbyImage = __webpack_require__(18);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _changeCase = __webpack_require__(322);
	
	var _changeCase2 = _interopRequireDefault(_changeCase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GridItem = function (_Component) {
	  _inherits(GridItem, _Component);
	
	  function GridItem() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, GridItem);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	      isHover: false
	    }, _this.addHover = function () {
	      _this.setState({ isHover: true });
	    }, _this.removeHover = function () {
	      _this.setState({ isHover: false });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  GridItem.prototype.render = function render() {
	    var _props = this.props,
	        imageMap = _props.imageMap,
	        link = _props.link,
	        className = _props.className;
	    var isHover = this.state.isHover;
	
	    var title = link;
	    var snakeLink = _changeCase2.default.headerCase(link).toLowerCase();
	
	    switch (link) {
	      case 'progetto':
	        title = 'Il Progetto';
	        break;
	      case 'sottoprogetti':
	        title = 'Sotto-progetti';
	        break;
	      case 'pubblicazioni':
	        title = 'Pubblicazioni e risorse';
	        break;
	      case 'gruppoDiRicerca':
	        title = 'Gruppo di ricerca';
	        break;
	    }
	
	    return _react2.default.createElement(
	      _gatsbyLink2.default,
	      {
	        to: '/' + snakeLink,
	        className: 'LinksGrid__Item ' + (className || ''),
	        onMouseEnter: this.addHover,
	        onMouseLeave: this.removeHover,
	        onClick: this.removeHover
	      },
	      _react2.default.createElement(_gatsbyImage2.default, {
	        critical: true,
	        sizes: imageMap[link].node.sizes,
	        style: {
	          position: 'absolute',
	          left: 0,
	          top: 0,
	          width: '100%',
	          height: '100%',
	          zIndex: isHover ? -1 : 0
	        }
	      }),
	      _react2.default.createElement(_gatsbyImage2.default, {
	        fadeIn: false,
	        sizes: imageMap[link + 'Hover'].node.sizes,
	        style: {
	          position: 'absolute',
	          left: 0,
	          top: 0,
	          width: '100%',
	          height: '100%',
	          zIndex: isHover ? 0 : -1
	        }
	      }),
	      _react2.default.createElement(
	        'div',
	        { className: 'LinksGrid__Item__Title' },
	        '' + title
	      )
	    );
	  };
	
	  return GridItem;
	}(_react.Component);
	
	exports.default = GridItem;
	module.exports = exports['default'];

/***/ }),

/***/ 293:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyImage = __webpack_require__(18);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _animatedScrollTo = __webpack_require__(139);
	
	var _animatedScrollTo2 = _interopRequireDefault(_animatedScrollTo);
	
	__webpack_require__(593);
	
	var _curveHorizontal = __webpack_require__(735);
	
	var _curveHorizontal2 = _interopRequireDefault(_curveHorizontal);
	
	var _curveVertical = __webpack_require__(736);
	
	var _curveVertical2 = _interopRequireDefault(_curveVertical);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Header = function (_Component) {
	  _inherits(Header, _Component);
	
	  function Header() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Header);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.handleChevronIconClick = function () {
	      (0, _animatedScrollTo2.default)(document.querySelector('.Main'));
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Header.prototype.render = function render() {
	    var headerImage = this.props.images.find(function (image) {
	      return image.node.sizes.src.indexOf('splash') >= 0;
	    });
	
	    return _react2.default.createElement(
	      'header',
	      { className: 'Header' },
	      _react2.default.createElement(
	        'div',
	        { className: 'Header__Left' },
	        _react2.default.createElement(
	          'div',
	          { className: 'Header__Left__Title' },
	          _react2.default.createElement(
	            'h1',
	            null,
	            _react2.default.createElement(
	              'div',
	              null,
	              'Milan and Ticino'
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              '(1796-1848).'
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              'Shaping'
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              'the Spatiality'
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              'of a European'
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              'Capital'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'Header__Left__ArrowContainer' },
	          _react2.default.createElement(
	            'button',
	            {
	              className: 'Header__Left__Arrow',
	              onClick: this.handleChevronIconClick
	            },
	            _react2.default.createElement(
	              'svg',
	              {
	                className: 'bounce',
	                xmlns: 'http://www.w3.org/2000/svg',
	                viewBox: '0 0 50 50'
	              },
	              _react2.default.createElement('line', { x1: '2.5', y1: '25', x2: '25', y2: '48' }),
	              _react2.default.createElement('line', { x1: '25', y1: '48', x2: '47.5', y2: '25' })
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'Header__Right' },
	        _react2.default.createElement('div', {
	          className: 'Header__Triangles__Right',
	          style: {
	            backgroundImage: 'url(' + _curveVertical2.default + ')',
	            backgroundRepeat: 'repeat-y'
	          }
	        }),
	        _react2.default.createElement('div', {
	          className: 'Header__Triangles__Down',
	          style: {
	            backgroundImage: 'url(' + _curveHorizontal2.default + ')',
	            backgroundRepeat: 'repeat-x'
	          }
	        }),
	        _react2.default.createElement(_gatsbyImage2.default, {
	          sizes: headerImage.node.sizes,
	          style: {
	            position: 'absolute',
	            left: 0,
	            top: 0,
	            width: '100%',
	            height: '100%'
	          }
	        })
	      )
	    );
	  };
	
	  return Header;
	}(_react.Component);
	
	exports.default = Header;
	module.exports = exports['default'];

/***/ }),

/***/ 593:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 294:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gridItem = __webpack_require__(292);
	
	var _gridItem2 = _interopRequireDefault(_gridItem);
	
	__webpack_require__(594);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LinksGrid = function (_Component) {
	  _inherits(LinksGrid, _Component);
	
	  function LinksGrid() {
	    _classCallCheck(this, LinksGrid);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  LinksGrid.prototype.render = function render() {
	    var _props = this.props,
	        imageMap = _props.imageMap,
	        links = _props.links;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'bg-primary py-2 mt-4' },
	      _react2.default.createElement(
	        'div',
	        { className: 'wrap-narrower' },
	        _react2.default.createElement(
	          'div',
	          { className: 'LinksGrid__Title' },
	          'Continua a navigare'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'LinksGrid mt-2' },
	          links.map(function (link, i) {
	            return _react2.default.createElement(_gridItem2.default, {
	              key: i,
	              link: link,
	              imageMap: imageMap,
	              className: 'LinksGrid__Item--small'
	            });
	          })
	        )
	      )
	    );
	  };
	
	  return LinksGrid;
	}(_react.Component);
	
	exports.default = LinksGrid;
	module.exports = exports['default'];

/***/ }),

/***/ 594:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 295:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(25);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _arrowRight = __webpack_require__(737);
	
	var _arrowRight2 = _interopRequireDefault(_arrowRight);
	
	__webpack_require__(595);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Menu = function Menu(_ref) {
	  var onLinkClick = _ref.onLinkClick;
	  return _react2.default.createElement(
	    'div',
	    { className: 'Menu' },
	    _react2.default.createElement(
	      'div',
	      { className: 'wrap' },
	      _react2.default.createElement(
	        'div',
	        { className: 'Menu__Row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'Menu__Column Menu__Column--left' },
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/', onClick: onLinkClick },
	            _react2.default.createElement(
	              'h1',
	              { className: 'text-bold' },
	              'Milan and Ticino',
	              _react2.default.createElement('br', null),
	              '(1796-1848).',
	              _react2.default.createElement('br', null),
	              'Shaping',
	              _react2.default.createElement('br', null),
	              'the Spatiality',
	              _react2.default.createElement('br', null),
	              'of a European ',
	              _react2.default.createElement('br', null),
	              'Capital'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'Menu__Column Menu__Column--right' },
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/', className: 'Menu__Link', onClick: onLinkClick },
	            'Home Page',
	            _react2.default.createElement('img', { src: _arrowRight2.default, alt: 'Arrow icon' })
	          ),
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/progetto', className: 'Menu__Link', onClick: onLinkClick },
	            'Il Progetto',
	            _react2.default.createElement('img', { src: _arrowRight2.default, alt: 'Arrow icon' })
	          ),
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            {
	              to: '/sottoprogetti',
	              className: 'Menu__Link',
	              onClick: onLinkClick
	            },
	            'Sotto-progetti',
	            _react2.default.createElement('img', { src: _arrowRight2.default, alt: 'Arrow icon' })
	          ),
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/agenda', className: 'Menu__Link', onClick: onLinkClick },
	            'Agenda',
	            _react2.default.createElement('img', { src: _arrowRight2.default, alt: 'Arrow icon' })
	          ),
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            {
	              to: '/pubblicazioni',
	              className: 'Menu__Link',
	              onClick: onLinkClick
	            },
	            'Pubblicazioni',
	            _react2.default.createElement('img', { src: _arrowRight2.default, alt: 'Arrow icon' })
	          ),
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            {
	              to: '/gruppo-di-ricerca',
	              className: 'Menu__Link',
	              onClick: onLinkClick
	            },
	            'Gruppo di Ricerca',
	            _react2.default.createElement('img', { src: _arrowRight2.default, alt: 'Arrow icon' })
	          ),
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/contatti', className: 'Menu__Link', onClick: onLinkClick },
	            'Contatti',
	            _react2.default.createElement('img', { src: _arrowRight2.default, alt: 'Arrow icon' })
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = Menu;
	module.exports = exports['default'];

/***/ }),

/***/ 595:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 296:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(25);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactTransitionGroup = __webpack_require__(138);
	
	var _menu = __webpack_require__(295);
	
	var _menu2 = _interopRequireDefault(_menu);
	
	var _circle = __webpack_require__(299);
	
	var _circle2 = _interopRequireDefault(_circle);
	
	__webpack_require__(596);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Nav = function (_Component) {
	  _inherits(Nav, _Component);
	
	  function Nav() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Nav);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = { isMenuVisible: false }, _this.toggleMenu = function () {
	      _this.setState({ isMenuVisible: !_this.state.isMenuVisible }, function () {
	        if (_this.state.isMenuVisible) {
	          return document.body.style.overflow = 'hidden';
	        }
	
	        document.body.style.overflow = 'auto';
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Nav.prototype.render = function render() {
	    var visible = this.props.visible;
	
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'Nav ' + (visible ? 'Nav--visible' : '') },
	        _react2.default.createElement(
	          'button',
	          {
	            className: 'hamburger hamburger--slider ' + (this.state.isMenuVisible ? 'is-active' : ''),
	            type: 'button',
	            onClick: this.toggleMenu
	          },
	          _react2.default.createElement(
	            'span',
	            { className: 'hamburger-box' },
	            _react2.default.createElement('span', { className: 'hamburger-inner' })
	          )
	        ),
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { className: 'Nav__HomeLink', to: '/' },
	          _react2.default.createElement(_circle2.default, null)
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: { width: '50px' } },
	          '\xA0'
	        )
	      ),
	      _react2.default.createElement(
	        _reactTransitionGroup.CSSTransition,
	        {
	          'in': this.state.isMenuVisible,
	          timeout: 200,
	          classNames: 'Nav__MenuContainer',
	          unmountOnExit: true
	        },
	        _react2.default.createElement(_menu2.default, { onLinkClick: this.toggleMenu })
	      )
	    );
	  };
	
	  return Nav;
	}(_react.Component);
	
	exports.default = Nav;
	module.exports = exports['default'];

/***/ }),

/***/ 596:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 297:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ScrollTrack = function (_Component) {
	  _inherits(ScrollTrack, _Component);
	
	  function ScrollTrack() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ScrollTrack);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = { amountscrolled: 0 }, _this.handleWindowResize = function () {
	      _this.getmeasurements();
	      requestAnimationFrame(_this.amountscrolled);
	    }, _this.handleScroll = function () {
	      requestAnimationFrame(_this.amountscrolled);
	    }, _this.getmeasurements = function () {
	      var winheight = window.innerHeight || (document.documentElement || document.body).clientHeight;
	
	      var docheight = _this.getDocHeight();
	      _this.trackLength = docheight - winheight;
	    }, _this.getDocHeight = function () {
	      var D = document;
	
	      return Math.max(D.body.scrollHeight, D.documentElement.scrollHeight, D.body.offsetHeight, D.documentElement.offsetHeight, D.body.clientHeight, D.documentElement.clientHeight);
	    }, _this.amountscrolled = function () {
	      var scrollTop = window.pageYOffset || (document.documentElement || document.body.parentNode || document.body).scrollTop;
	      var pctScrolled = Math.floor(scrollTop / _this.trackLength * 100);
	      _this.setState({ amountscrolled: pctScrolled });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  ScrollTrack.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    setTimeout(function () {
	      _this2.getmeasurements();
	
	      if (window) {
	        window.addEventListener('resize', _this2.handleWindowResize);
	        window.addEventListener('scroll', _this2.handleScroll);
	      }
	    }, 1000);
	  };
	
	  ScrollTrack.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (window) {
	      window.removeEventListener('resize', this.handleWindowResize);
	      window.removeEventListener('scroll', this.handleScroll);
	    }
	  };
	
	  ScrollTrack.prototype.render = function render() {
	    return _react2.default.createElement('div', {
	      className: 'Nav__ScrollTrack',
	      style: { width: this.state.amountscrolled + '%' }
	    });
	  };
	
	  return ScrollTrack;
	}(_react.Component);
	
	exports.default = ScrollTrack;
	module.exports = exports['default'];

/***/ }),

/***/ 299:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Circle = function Circle(props) {
	  return _react2.default.createElement(
	    "svg",
	    {
	      fill: "transparent",
	      viewBox: "0 0 50 50",
	      className: "CircleIcon " + (props.className || '')
	    },
	    _react2.default.createElement("circle", { strokeWidth: 4, cx: 25, cy: 25, r: 21 })
	  );
	};
	
	exports.default = Circle;
	module.exports = exports["default"];

/***/ }),

/***/ 735:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTAwcHgiIGhlaWdodD0iMjBweCIgdmlld0JveD0iMCAwIDEwMCAyMCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIj4KICAgIDwhLS0gR2VuZXJhdG9yOiBTa2V0Y2ggNTEuMiAoNTc1MTkpIC0gaHR0cDovL3d3dy5ib2hlbWlhbmNvZGluZy5jb20vc2tldGNoIC0tPgogICAgPHRpdGxlPlBhdGggNDwvdGl0bGU+CiAgICA8ZGVzYz5DcmVhdGVkIHdpdGggU2tldGNoLjwvZGVzYz4KICAgIDxkZWZzPjwvZGVmcz4KICAgIDxnIGlkPSJQYWdlLTEiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIwIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxwYXRoIGQ9Ik0xLjEzNjg2ODM4ZS0xMywwIEMxMy4zMzk1NDk1LDAgMzAuMDA2MjE2MiwwIDUwLDAgQzc4Ljg2NDg1NTUsMCA5NS41MzE1MjIyLDAgMTAwLDAgQzc2Ljk4ODA2MTYsMCA3NS40NTM0MTIxLDIwIDUwLDIwIEMyNC41NDY1ODc5LDIwIDI3LjA4MTIzNzQsMCAxLjEzNjg2ODM4ZS0xMywwIFoiIGlkPSJQYXRoLTQiIGZpbGw9IiNDOEM1QjYiIGZpbGwtcnVsZT0ibm9uemVybyI+PC9wYXRoPgogICAgPC9nPgo8L3N2Zz4="

/***/ }),

/***/ 736:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjBweCIgaGVpZ2h0PSIxMDBweCIgdmlld0JveD0iMCAwIDIwIDEwMCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIj4KICAgIDwhLS0gR2VuZXJhdG9yOiBTa2V0Y2ggNTEuMiAoNTc1MTkpIC0gaHR0cDovL3d3dy5ib2hlbWlhbmNvZGluZy5jb20vc2tldGNoIC0tPgogICAgPHRpdGxlPlBhdGggNDwvdGl0bGU+CiAgICA8ZGVzYz5DcmVhdGVkIHdpdGggU2tldGNoLjwvZGVzYz4KICAgIDxkZWZzPjwvZGVmcz4KICAgIDxnIGlkPSJQYWdlLTEiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIwIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxwYXRoIGQ9Ik0tNDAsNDAgQy0yNi42NjA0NTA1LDQwIC05Ljk5Mzc4MzgxLDQwIDEwLDQwIEMzOC44NjQ4NTU1LDQwIDU1LjUzMTUyMjIsNDAgNjAsNDAgQzM2Ljk4ODA2MTYsNDAgMzUuNDUzNDEyMSw2MCAxMCw2MCBDLTE1LjQ1MzQxMjEsNjAgLTEyLjkxODc2MjYsNDAgLTQwLDQwIFoiIGlkPSJQYXRoLTQiIGZpbGw9IiNDOEM1QjYiIGZpbGwtcnVsZT0ibm9uemVybyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTAuMDAwMDAwLCA1MC4wMDAwMDApIHJvdGF0ZSgyNzAuMDAwMDAwKSB0cmFuc2xhdGUoLTEwLjAwMDAwMCwgLTUwLjAwMDAwMCkgIj48L3BhdGg+CiAgICA8L2c+Cjwvc3ZnPg=="

/***/ }),

/***/ 737:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI1MCIgaGVpZ2h0PSI1MCI+CiAgPGxpbmUgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjMDAwIiBzdHJva2Utd2lkdGg9IjYiIHgxPSIzIiB5MT0iMjUiIHgyPSI0NyIgeTI9IjI1IiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4KICA8bGluZSBmaWxsPSJub25lIiBzdHJva2U9IiMwMDAiIHN0cm9rZS13aWR0aD0iNiIgeDE9IjQ3IiB5MT0iMjUiIHgyPSIyNSIgeTI9IjMiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgogIDxsaW5lIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzAwMCIgc3Ryb2tlLXdpZHRoPSI2IiB4MT0iNDciIHkxPSIyNSIgeDI9IjI1IiB5Mj0iNDciIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgo8L3N2Zz4K"

/***/ }),

/***/ 300:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _header = __webpack_require__(293);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _footer = __webpack_require__(291);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _nav = __webpack_require__(296);
	
	var _nav2 = _interopRequireDefault(_nav);
	
	__webpack_require__(605);
	
	var _scrollTrack = __webpack_require__(297);
	
	var _scrollTrack2 = _interopRequireDefault(_scrollTrack);
	
	var _linksGrid = __webpack_require__(294);
	
	var _linksGrid2 = _interopRequireDefault(_linksGrid);
	
	var _withRouter = __webpack_require__(270);
	
	var _withRouter2 = _interopRequireDefault(_withRouter);
	
	var _reactTransitionGroup = __webpack_require__(138);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TransitionHandler = function (_React$Component) {
	  _inherits(TransitionHandler, _React$Component);
	
	  function TransitionHandler() {
	    _classCallCheck(this, TransitionHandler);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  TransitionHandler.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
	    return this.props.location.pathname === window.location.pathname;
	  };
	
	  TransitionHandler.prototype.render = function render() {
	    var children = this.props.children;
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'transition-container' },
	      children
	    );
	  };
	
	  return TransitionHandler;
	}(_react2.default.Component);
	
	var Layout = function (_Component) {
	  _inherits(Layout, _Component);
	
	  function Layout() {
	    var _temp, _this2, _ret;
	
	    _classCallCheck(this, Layout);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this2 = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this2), _this2.lastKnownScrollPosition = 0, _this2.isTicking = false, _this2.scrollThreshold = 0, _this2.vieportHeight = 0, _this2.state = {
	      isNavVisible: typeof location === 'undefined' || location.pathname === '/' ? false : true
	    }, _this2.checkNavVisibility = function (scrollPosition) {
	      if (scrollPosition >= _this2.scrollThreshold && !_this2.state.isNavVisible) {
	        return _this2.setState({ isNavVisible: true });
	      }
	
	      if (scrollPosition < _this2.scrollThreshold && _this2.state.isNavVisible) {
	        _this2.setState({ isNavVisible: false });
	      }
	    }, _this2.renderGrid = function (location, data) {
	      var locationArray = location.pathname.split('/');
	      var currentPage = locationArray[1] === '' ? '/' : locationArray[1];
	      var allImages = data.allImageSharp.edges;
	
	      var imageMap = {
	        agenda: allImages.find(function (image) {
	          return image.node.sizes.src.indexOf('agenda_base') >= 0;
	        }),
	        agendaHover: allImages.find(function (image) {
	          return image.node.sizes.src.indexOf('agenda_hover') >= 0;
	        }),
	        pubblicazioni: allImages.find(function (image) {
	          return image.node.sizes.src.indexOf('pubbl_base') >= 0;
	        }),
	        pubblicazioniHover: allImages.find(function (image) {
	          return image.node.sizes.src.indexOf('pubblicazioni_hover') >= 0;
	        }),
	        progetto: allImages.find(function (image) {
	          return image.node.sizes.src.indexOf('progetto_base') >= 0;
	        }),
	        progettoHover: allImages.find(function (image) {
	          return image.node.sizes.src.indexOf('progetto_hover') >= 0;
	        }),
	        sottoprogetti: allImages.find(function (image) {
	          return image.node.sizes.src.indexOf('sottoprogetti') >= 0;
	        }),
	        sottoprogettiHover: allImages.find(function (image) {
	          return image.node.sizes.src.indexOf('sottoprogetti') >= 0;
	        }),
	        gruppoDiRicerca: allImages.find(function (image) {
	          return image.node.sizes.src.indexOf('splash') >= 0;
	        }),
	        gruppoDiRicercaHover: allImages.find(function (image) {
	          return image.node.sizes.src.indexOf('splash') >= 0;
	        })
	      };
	
	      switch (currentPage) {
	        case 'progetto':
	          return _react2.default.createElement(_linksGrid2.default, {
	            imageMap: imageMap,
	            links: ['sottoprogetti', 'agenda', 'pubblicazioni', 'gruppoDiRicerca']
	          });
	        case 'agenda':
	          return _react2.default.createElement(_linksGrid2.default, {
	            imageMap: imageMap,
	            links: ['progetto', 'sottoprogetti', 'pubblicazioni', 'gruppoDiRicerca']
	          });
	        case 'pubblicazioni':
	          return _react2.default.createElement(_linksGrid2.default, {
	            imageMap: imageMap,
	            links: ['progetto', 'agenda', 'sottoprogetti', 'gruppoDiRicerca']
	          });
	        case 'gruppo-di-ricerca':
	          return _react2.default.createElement(_linksGrid2.default, {
	            imageMap: imageMap,
	            links: ['progetto', 'sottoprogetti', 'pubblicazioni', 'agenda']
	          });
	        default:
	          return _react2.default.createElement(_linksGrid2.default, {
	            imageMap: imageMap,
	            links: ['sottoprogetti', 'agenda', 'pubblicazioni', 'gruppoDiRicerca']
	          });
	      }
	    }, _temp), _possibleConstructorReturn(_this2, _ret);
	  }
	
	  Layout.prototype.componentDidMount = function componentDidMount() {
	    var _this3 = this;
	
	    if (window && location) {
	      this.vieportHeight = window.innerHeight;
	
	      window.addEventListener('scroll', function () {
	        _this3.lastKnownScrollPosition = window.scrollY;
	        // Imposto la scrollThreshold all'altezza del viewport solo se sono
	        // in home. In tutte le altre pagine la nav deve essere sempre visibile
	        _this3.scrollThreshold = location.pathname === '/' ? 10 : 0;
	
	        if (!_this3.isTicking) {
	          window.requestAnimationFrame(function () {
	            _this3.checkNavVisibility(_this3.lastKnownScrollPosition);
	            _this3.isTicking = false;
	          });
	
	          _this3.isTicking = true;
	        }
	      });
	    }
	  };
	
	  Layout.prototype.render = function render() {
	    var _props = this.props,
	        children = _props.children,
	        location = _props.location,
	        data = _props.data;
	
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      location.pathname === '/' && _react2.default.createElement(_header2.default, { images: data.allImageSharp.edges }),
	      _react2.default.createElement(_nav2.default, { visible: this.state.isNavVisible }),
	      location.pathname.startsWith('/progetto') && _react2.default.createElement(_scrollTrack2.default, null),
	      _react2.default.createElement(
	        _reactTransitionGroup.TransitionGroup,
	        null,
	        _react2.default.createElement(
	          _reactTransitionGroup.CSSTransition,
	          {
	            key: location.pathname,
	            classNames: 'fadein',
	            timeout: { enter: 200, exit: 100 }
	          },
	          _react2.default.createElement(
	            TransitionHandler,
	            { location: location },
	            _react2.default.createElement(
	              'main',
	              { className: 'Main' },
	              children(),
	              this.renderGrid(location, data)
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(_footer2.default, { images: data.allImageSharp.edges })
	    );
	  };
	
	  return Layout;
	}(_react.Component);
	
	exports.default = (0, _withRouter2.default)(Layout);
	var query = exports.query = '** extracted graphql fragment **';

/***/ }),

/***/ 605:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-bf4b42d7be67d4500867.js